<kpi-tab-content #callToActionTab [tabIndex]="0">
  <kpi-group #callToActionClientsGroup [title]="'Clientes'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (callToActionPastPendingOrdersHostVisible) {
        <kpi-host kpiId="tourKpi" kpiMenuId="tourKpiMenu" #callToActionPastPendingOrdersHost
            [title]="'Peticiones pdtes. vencidas'"
            [refreshing]="callToActionPastPendingOrdersServiceHost.loading"
            [warn]="callToActionPastPendingOrdersServiceHost.warn"
            [lastUpdatedText]="callToActionPastPendingOrdersServiceHost.lastUpdatedText"
            (detailRequested)="callToActionPastPendingOrdersServiceHost.showDetail($event)">
            <i icon class="material-icons">shopping_cart</i>
            <kpi-host-menu-option optionId="tourKpiOption" menuOption [text]="'Actualizar'"
                (click)="callToActionPastPendingOrdersServiceHost.refresh()"></kpi-host-menu-option>
            <past-pending-orders-kpi-service-host sink #callToActionPastPendingOrdersServiceHost>
            </past-pending-orders-kpi-service-host>
            <ng-container mainData>
              @if (!callToActionPastPendingOrdersServiceHost.summaryData && !callToActionPastPendingOrdersServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (callToActionPastPendingOrdersServiceHost.summaryData) {
                <dual-data #callToActionPastPendingOrdersDualData
                  [valueA]="callToActionPastPendingOrdersServiceHost.summaryData.consultantTotal"
                  [valueAStyle]="callToActionPastPendingOrdersServiceHost.summaryData.consultantTotal == 0 && !callToActionPastPendingOrdersServiceHost.warn ? callToActionPastPendingOrdersDualData.dataValueStyle.Zero : callToActionPastPendingOrdersDualData.dataValueStyle.None"
                  [iconA]="callToActionPastPendingOrdersDualData.dataIcon.User"
                  footerA="{{callToActionPastPendingOrdersServiceHost.summaryData.consultantBuckets}} de buckets"
                  (valueAClick)="callToActionPastPendingOrdersServiceHost.mergeFilter({ consultant: true })"
                  [valueB]="callToActionPastPendingOrdersServiceHost.summaryData.officeTotal"
                  [valueBStyle]="callToActionPastPendingOrdersServiceHost.summaryData.officeTotal == 0 && !callToActionPastPendingOrdersServiceHost.warn ? callToActionPastPendingOrdersDualData.dataValueStyle.Zero : callToActionPastPendingOrdersDualData.dataValueStyle.None"
                  footerB="{{callToActionPastPendingOrdersServiceHost.summaryData.officeBuckets}} de buckets"
                  [iconB]="callToActionPastPendingOrdersDualData.dataIcon.Office"
                  (valueBClick)="callToActionPastPendingOrdersServiceHost.mergeFilter({ consultant: false })">
                </dual-data>
              }
            </ng-container>

            @if (callToActionPastPendingOrdersServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="callToActionPastPendingOrdersServiceHost.summaryError.message"
                (onRequestRefresh)="callToActionPastPendingOrdersServiceHost.refresh()">
              </data-error>
            }
        </kpi-host>
      }

      @if (callToActionInmediatePendingOrdersTEAHostVisible) {
        <kpi-host kpiId="tourKpi_1" #callToActionInmediatePendingOrdersTEAHost
            [title]="'Peticiones pdtes. ETT'"
            [refreshing]="callToActionInmediatePendingOrdersTEAServiceHost.loading"
            [warn]="callToActionInmediatePendingOrdersTEAServiceHost.warn"
            [lastUpdatedText]="callToActionInmediatePendingOrdersTEAServiceHost.lastUpdatedText"
            (detailRequested)="callToActionInmediatePendingOrdersTEAServiceHost.showDetail($event)">
            <i icon class="material-icons">shopping_cart</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="callToActionInmediatePendingOrdersTEAServiceHost.refresh()"></kpi-host-menu-option>
            <inmediate-pending-orders-tea-kpi-service-host sink #callToActionInmediatePendingOrdersTEAServiceHost>
            </inmediate-pending-orders-tea-kpi-service-host>
            <ng-container mainData>
              @if (!callToActionInmediatePendingOrdersTEAServiceHost.summaryData && !callToActionInmediatePendingOrdersTEAServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (callToActionInmediatePendingOrdersTEAServiceHost.summaryData) {
                <dual-data #callToActionInmediatePendingOrdersTEADualData
                  [valueA]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.consultantTotal"
                  [valueAStyle]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.consultantTotal == 0 ? callToActionInmediatePendingOrdersTEADualData.dataValueStyle.Zero : callToActionInmediatePendingOrdersTEADualData.dataValueStyle.None"
                  footerA="{{callToActionInmediatePendingOrdersTEAServiceHost.summaryData.consultantBuckets}} de buckets"
                  [footerAStyle]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.consultantBuckets == 0 ? callToActionInmediatePendingOrdersTEADualData.dataValueStyle.None : callToActionInmediatePendingOrdersTEADualData.dataValueStyle.Warn"
                  [iconA]="callToActionInmediatePendingOrdersTEADualData.dataIcon.User"
                  [valueB]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.officeTotal"
                  [valueBStyle]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.officeTotal == 0 ? callToActionInmediatePendingOrdersTEADualData.dataValueStyle.Zero : callToActionInmediatePendingOrdersTEADualData.dataValueStyle.None"
                  footerB="{{callToActionInmediatePendingOrdersTEAServiceHost.summaryData.officeBuckets}} de buckets"
                  [footerBStyle]="callToActionInmediatePendingOrdersTEAServiceHost.summaryData.officeBuckets == 0 ? callToActionInmediatePendingOrdersTEADualData.dataValueStyle.None : callToActionInmediatePendingOrdersTEADualData.dataValueStyle.Warn"
                  [iconB]="callToActionInmediatePendingOrdersTEADualData.dataIcon.Office">
                </dual-data>
              }
            </ng-container>

            @if (callToActionInmediatePendingOrdersTEAServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="callToActionInmediatePendingOrdersTEAServiceHost.summaryError.message"
                (onRequestRefresh)="callToActionInmediatePendingOrdersTEAServiceHost.refresh()">
              </data-error>
            }
        </kpi-host>
      }

      @if (callToActionInmediatePendingOrdersPermHostVisible) {
        <kpi-host kpiId="tourKpi_2" #callToActionInmediatePendingOrdersPermHost
            [title]="'Peticiones pdtes. Perm'"
            [refreshing]="callToActionInmediatePendingOrdersPermServiceHost.loading"
            [warn]="callToActionInmediatePendingOrdersPermServiceHost.warn"
            [lastUpdatedText]="callToActionInmediatePendingOrdersPermServiceHost.lastUpdatedText"
            (detailRequested)="callToActionInmediatePendingOrdersPermServiceHost.showDetail($event)">
            <i icon class="material-icons">shopping_cart</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="callToActionInmediatePendingOrdersPermServiceHost.refresh()"></kpi-host-menu-option>
            <inmediate-pending-orders-perm-kpi-service-host sink #callToActionInmediatePendingOrdersPermServiceHost>
            </inmediate-pending-orders-perm-kpi-service-host>
            <ng-container mainData>
              @if (!callToActionInmediatePendingOrdersPermServiceHost.summaryData && !callToActionInmediatePendingOrdersPermServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (callToActionInmediatePendingOrdersPermServiceHost.summaryData) {
                <dual-data #callToActionInmediatePendingOrdersPermDualData
                  [valueA]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.consultantTotal"
                  [valueAStyle]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.consultantTotal == 0 ? callToActionInmediatePendingOrdersPermDualData.dataValueStyle.Zero : callToActionInmediatePendingOrdersPermDualData.dataValueStyle.None"
                  footerA="{{callToActionInmediatePendingOrdersPermServiceHost.summaryData.consultantBuckets}} de buckets"
                  [footerAStyle]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.consultantBuckets == 0 ? callToActionInmediatePendingOrdersPermDualData.dataValueStyle.None : callToActionInmediatePendingOrdersPermDualData.dataValueStyle.Warn"
                  [iconA]="callToActionInmediatePendingOrdersPermDualData.dataIcon.User"
                  [valueB]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.officeTotal"
                  [valueBStyle]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.officeTotal == 0 ? callToActionInmediatePendingOrdersPermDualData.dataValueStyle.Zero : callToActionInmediatePendingOrdersPermDualData.dataValueStyle.None"
                  footerB="{{callToActionInmediatePendingOrdersPermServiceHost.summaryData.officeBuckets}} de buckets"
                  [footerBStyle]="callToActionInmediatePendingOrdersPermServiceHost.summaryData.officeBuckets == 0 ? callToActionInmediatePendingOrdersPermDualData.dataValueStyle.None : callToActionInmediatePendingOrdersPermDualData.dataValueStyle.Warn"
                  [iconB]="callToActionInmediatePendingOrdersPermDualData.dataIcon.Office">
                </dual-data>
              }
            </ng-container>

            @if (callToActionInmediatePendingOrdersPermServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="callToActionInmediatePendingOrdersPermServiceHost.summaryError.message"
                (onRequestRefresh)="callToActionInmediatePendingOrdersPermServiceHost.refresh()">
            </data-error>
            }
        </kpi-host>
      }

      @if (clientsVisitsPerformedHostVisible) {
        <kpi-host #clientsVisitsPerformedHost [title]="'Visitas realizadas semana'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza todos los días a las 7 am de cada día"
            [refreshing]="clientsVisitsPerformedServiceHost.loading" [warn]="clientsVisitsPerformedServiceHost.warn"
            [lastUpdatedText]="clientsVisitsPerformedServiceHost.lastUpdatedText"
            (detailRequested)="clientsVisitsPerformedServiceHost.showDetail($event)">
            <i icon class="material-icons">work</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="clientsVisitsPerformedServiceHost.refresh()"></kpi-host-menu-option>
            <visits-target-kpi-service-host sink #clientsVisitsPerformedServiceHost
              [detailDialog]="clientsVisitsPerformedDetailDialog"
              [messageDialog]="clientsVisitsPerformedMessageDialog">
            </visits-target-kpi-service-host>
            <ng-container mainData>
              @if (!clientsVisitsPerformedServiceHost.summaryData && !clientsVisitsPerformedServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsVisitsPerformedServiceHost.summaryData) {
                <single-data #clientsVisitsPerformedSingleData
                  [value]="clientsVisitsPerformedServiceHost.summaryData.visits"
                  subValue="de {{clientsVisitsPerformedServiceHost.summaryData.target}}"
                  [icon]="clientsVisitsPerformedSingleData.dataIcon.User">
                </single-data>
              }
            </ng-container>

            @if (clientsVisitsPerformedServiceHost.summaryData) {
              <progress-bar additionalData [value]="clientsVisitsPerformedServiceHost.summaryData.progress"
                text="{{clientsVisitsPerformedServiceHost.summaryData.progress.toFixed(1)}}%">
              </progress-bar>
            }

            @if (clientsVisitsPerformedServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsVisitsPerformedServiceHost.summaryError.message"
                (onRequestRefresh)="clientsVisitsPerformedServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsVisitsPerformedDetailDialog
                [title]="'Visitas realizadas esta semana'" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDetailDialog.dialogSize.Large">

                @if (clientsVisitsPerformedDetailDialog.visible && clientsVisitsPerformedServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsVisitsPerformedServiceHost.detailData.columnDefinitions"
                    [data]="clientsVisitsPerformedServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsVisitsPerformedDetailDialog.visible && clientsVisitsPerformedServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }

            </modal-dialog>
            <modal-dialog detailDialog #clientsVisitsPerformedMessageDialog [title]="''" cancelText="Cerrar"
                [size]="clientsVisitsPerformedMessageDialog.dialogSize.Small">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                    todos los días a las 7 am</p>
            </modal-dialog>
        </kpi-host>
      }

      @if (clientsVisitsPerformedDOHostVisible) {
        <kpi-host #clientsVisitsPerformedDOHost
            [title]="'Visitas realizadas semana'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza todos los días a las 7 am de cada día"
            [refreshing]="clientsVisitsPerformedDOServiceHost.loading"
            [warn]="clientsVisitsPerformedDOServiceHost.warn"
            [lastUpdatedText]="clientsVisitsPerformedDOServiceHost.lastUpdatedText"
            (detailRequested)="clientsVisitsPerformedDOServiceHost.showDetail($event)">
            <i icon class="material-icons">work</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsVisitsPerformedDOServiceHost.refresh()"></kpi-host-menu-option>
            <visits-target-do-kpi-service-host sink #clientsVisitsPerformedDOServiceHost
                [detailDialog]="clientsVisitsPerformedDODetailDialog"
                [messageDialog]="clientsVisitsPerformedDOMessageDialog">
            </visits-target-do-kpi-service-host>
            <ng-container mainData>
              @if (!clientsVisitsPerformedDOServiceHost.summaryData && !clientsVisitsPerformedDOServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsVisitsPerformedDOServiceHost.summaryData) {
                <dual-data #clientsVisitsPerformedDODualData
                    [valueA]="clientsVisitsPerformedDOServiceHost.summaryData.visits"
                    footerA="de {{clientsVisitsPerformedDOServiceHost.summaryData.target}}"
                    [iconA]="clientsVisitsPerformedDODualData.dataIcon.User"
                    (valueAClick)="clientsVisitsPerformedDOServiceHost.mergeFilter({ wholeOffice: false })"
                    [valueB]="clientsVisitsPerformedDOServiceHost.summaryData.globalVisits"
                    footerB="de {{clientsVisitsPerformedDOServiceHost.summaryData.globalTarget}}"
                    [iconB]="clientsVisitsPerformedDODualData.dataIcon.Office"
                    (valueBClick)="clientsVisitsPerformedDOServiceHost.mergeFilter({ wholeOffice: true })">
                </dual-data>
              }
            </ng-container>

            @if (clientsVisitsPerformedDOServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsVisitsPerformedDOServiceHost.summaryError.message"
                (onRequestRefresh)="clientsVisitsPerformedDOServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsVisitsPerformedDODetailDialog
                [title]="'Visitas realizadas esta semana'" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDODetailDialog.dialogSize.Large">

                @if (clientsVisitsPerformedDODetailDialog.visible && clientsVisitsPerformedDOServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsVisitsPerformedDOServiceHost.detailData.columnDefinitions"
                    [data]="clientsVisitsPerformedDOServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsVisitsPerformedDODetailDialog.visible && clientsVisitsPerformedDOServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #clientsVisitsPerformedDOMessageDialog [title]="" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDOMessageDialog.dialogSize.Large">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                    todos los días a las 7 am</p>

            </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #callToActionTalentGroup [title]="'Talento'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (callToActionCandidatesBucketStatusHostVisible) {
        <kpi-host #callToActionCandidatesBucketStatusHost
          [title]="'Cand. pdtes FTG'" tooltip="Candidatos que me faltan en Focus Talent Groups"
          [refreshing]="callToActionCandidatesBucketStatusServiceHost.loading"
          [warn]="callToActionCandidatesBucketStatusServiceHost.warn"
          [lastUpdatedText]="callToActionCandidatesBucketStatusServiceHost.lastUpdatedText"
          (detailRequested)="callToActionCandidatesBucketStatusServiceHost.showDetail($event)">
          <i icon class="material-icons">people</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionCandidatesBucketStatusServiceHost.refresh()"></kpi-host-menu-option>
          <bucket-status-kpi-service-host sink #callToActionCandidatesBucketStatusServiceHost>
          </bucket-status-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionCandidatesBucketStatusServiceHost.summaryData && !callToActionCandidatesBucketStatusServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionCandidatesBucketStatusServiceHost.summaryData) {
              <single-data #callToActionCandidatesBucketStatusSingleData
                [value]="callToActionCandidatesBucketStatusServiceHost.summaryData.remaining"
                [valueStyle]="callToActionCandidatesBucketStatusServiceHost.summaryData.remaining == 0 ? callToActionCandidatesBucketStatusSingleData.dataValueStyle.Zero : callToActionCandidatesBucketStatusSingleData.dataValueStyle.Warn"
                [icon]="callToActionCandidatesBucketStatusSingleData.dataIcon.Office">
              </single-data>
            }
          </ng-container>

          @if (callToActionCandidatesBucketStatusServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="callToActionCandidatesBucketStatusServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionCandidatesBucketStatusServiceHost.refresh()">
          </data-error>
          }
        </kpi-host>
      }

      @if (callToActionDiscontinuousPermanentWorkersHostVisible) {
        <kpi-host #callToActionDiscontinuousPermanentWorkersHost
          [title]="'Trab. fijos discontinuos stand by'"
          tooltip="Trabajadores fijos discontinuos de tu oficina en estado stand by"
          [refreshing]="callToActionDiscontinuousPermanentWorkersServiceHost.loading"
          [warn]="callToActionDiscontinuousPermanentWorkersServiceHost.warn"
          [lastUpdatedText]="callToActionDiscontinuousPermanentWorkersServiceHost.lastUpdatedText"
          (detailRequested)="callToActionDiscontinuousPermanentWorkersServiceHost.showDetail($event)">
          <i icon class="material-icons">people</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionDiscontinuousPermanentWorkersServiceHost.refresh()"></kpi-host-menu-option>
          <discontinuous-permanent-workers-kpi-service-host sink
              #callToActionDiscontinuousPermanentWorkersServiceHost
              [detailDialog]="callToActionDiscontinuousPermanentWorkersDetailDialog"
              [messageDialog]="callToActionDiscontinuousPermanentWorkersMessageDialog">
          </discontinuous-permanent-workers-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionDiscontinuousPermanentWorkersServiceHost.summaryData && !callToActionDiscontinuousPermanentWorkersServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionDiscontinuousPermanentWorkersServiceHost.summaryData) {
              <single-data #callToActionDiscontinuousPermanentWorkersSingleData
                [value]="callToActionDiscontinuousPermanentWorkersServiceHost.summaryData.consultant"
                [valueStyle]="callToActionDiscontinuousPermanentWorkersServiceHost.summaryData.consultant == 0 ? callToActionDiscontinuousPermanentWorkersSingleData.dataValueStyle.Zero : callToActionDiscontinuousPermanentWorkersSingleData.dataValueStyle.Warn"
                [icon]="callToActionDiscontinuousPermanentWorkersSingleData.dataIcon.Office">
              </single-data>
            }
          </ng-container>
          @if (callToActionDiscontinuousPermanentWorkersServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionDiscontinuousPermanentWorkersServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionDiscontinuousPermanentWorkersServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionDiscontinuousPermanentWorkersDetailDialog
              [title]="'Trab. fijos discontinuos stand by'" cancelText="Cerrar"
              [size]="callToActionDiscontinuousPermanentWorkersDetailDialog.dialogSize.Large">
              @if (callToActionDiscontinuousPermanentWorkersDetailDialog.visible && callToActionDiscontinuousPermanentWorkersServiceHost.detailData) {
                <datatable [columnDefinitions]="callToActionDiscontinuousPermanentWorkersServiceHost.detailData.columnDefinitions"
                  [data]="callToActionDiscontinuousPermanentWorkersServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (callToActionDiscontinuousPermanentWorkersDetailDialog.visible && callToActionDiscontinuousPermanentWorkersServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
          <modal-dialog detailDialog #callToActionDiscontinuousPermanentWorkersMessageDialog [title]=""
              cancelText="Cerrar"
              [size]="callToActionDiscontinuousPermanentWorkersMessageDialog.dialogSize.Large">
              <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                  todos los días a las 7 am</p>

          </modal-dialog>
        </kpi-host>
      }

      @if (callToActionWorkersAppealPendingVisible) {
        <kpi-host #callToActionWorkersAppealPending
          [title]="'Llamamientos FD'" tooltip="Llamamientos de FD que están en estado pendiente"
          [refreshing]="callToActionWorkersAppealPendingServiceHost.loading"
          [warn]="callToActionWorkersAppealPendingServiceHost.warn"
          [lastUpdatedText]="callToActionWorkersAppealPendingServiceHost.lastUpdatedText"
          (detailRequested)="callToActionWorkersAppealPendingServiceHost.showDetail($event)">
          <i icon class="material-icons">people</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionWorkersAppealPendingServiceHost.refresh()"></kpi-host-menu-option>
          <workers-appeal-pending-kpi-service-host sink #callToActionWorkersAppealPendingServiceHost
              [detailDialog]="callToActionWorkersAppealPendingDetailDialog"
              [messageDialog]="callToActionWorkersAppealPendingMessageDialog">
          </workers-appeal-pending-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionWorkersAppealPendingServiceHost.summaryData && !callToActionWorkersAppealPendingServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionWorkersAppealPendingServiceHost.summaryData) {
              <dual-data #callToActionWorkersAppealPendingDualData
                  [valueA]="callToActionWorkersAppealPendingServiceHost.summaryData.consultant"
                  [iconA]="callToActionWorkersAppealPendingDualData.dataIcon.User"
                  (valueAClick)="callToActionWorkersAppealPendingServiceHost.mergeFilter({ consultant: true })"
                  [valueB]="callToActionWorkersAppealPendingServiceHost.summaryData.office"
                  [iconB]="callToActionWorkersAppealPendingDualData.dataIcon.Office"
                  (valueBClick)="callToActionWorkersAppealPendingServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (callToActionWorkersAppealPendingServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionWorkersAppealPendingServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionWorkersAppealPendingServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionWorkersAppealPendingDetailDialog
              [title]="'Llamamientos FD pendientes'" cancelText="Cerrar"
              [size]="callToActionWorkersAppealPendingDetailDialog.dialogSize.Large">

              @if (callToActionWorkersAppealPendingDetailDialog.visible && callToActionWorkersAppealPendingServiceHost.detailData) {
                <datatable [columnDefinitions]="callToActionWorkersAppealPendingServiceHost.detailData.columnDefinitions"
                  [data]="callToActionWorkersAppealPendingServiceHost.detailData.tabledata"
                  [rowStyleSelector]="callToActionWorkersAppealPendingServiceHost.detailData.rowStyleSelector">
                </datatable>
              }

              @if (callToActionWorkersAppealPendingDetailDialog.visible && callToActionWorkersAppealPendingServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }


          </modal-dialog>
          <modal-dialog detailDialog #callToActionWorkersAppealPendingMessageDialog [title]="" cancelText="Cerrar"
              [size]="callToActionWorkersAppealPendingMessageDialog.dialogSize.Large">
              <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                  todos los días a las 7 am</p>
          </modal-dialog>
      </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #callToActionManagementControlGroup [title]="'Gestión & Control'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (callToActionPastUnsignedContractsHostVisible) {
        <kpi-host #callToActionPastUnsignedContractsHost icon="border_color" [title]="'Ctr/pro/fin ctr pdtes firmar caducados'"
          tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar caducados: Se muestra contratos de máximo 15 dias para atrás"
          [refreshing]="callToActionPastUnsignedContractsServiceHost.loading"
          [warn]="callToActionPastUnsignedContractsServiceHost.warn"
          [lastUpdatedText]="callToActionPastUnsignedContractsServiceHost.lastUpdatedText"
          (detailRequested)="callToActionPastUnsignedContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionPastUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
          <past-unsigned-contracts-kpi-service-host sink #callToActionPastUnsignedContractsServiceHost
              [detailDialog]="callToActionPastUnsignedContractsDetailDialog">
          </past-unsigned-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionPastUnsignedContractsServiceHost.summaryData && !callToActionPastUnsignedContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionPastUnsignedContractsServiceHost.summaryData) {
              <dual-data #callToActionPastUnsignedContractsDualData
                [valueA]="callToActionPastUnsignedContractsServiceHost.summaryData.consultant"
                (valueAClick)="callToActionPastUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
                [valueAStyle]="callToActionPastUnsignedContractsServiceHost.summaryData.consultant == 0 && !callToActionPastUnsignedContractsServiceHost.warn ? callToActionPastUnsignedContractsDualData.dataValueStyle.Zero : callToActionPastUnsignedContractsDualData.dataValueStyle.None"
                [iconA]="callToActionPastUnsignedContractsDualData.dataIcon.User"
                [valueB]="callToActionPastUnsignedContractsServiceHost.summaryData.office"
                [valueBStyle]="callToActionPastUnsignedContractsServiceHost.summaryData.office == 0 && !callToActionPastUnsignedContractsServiceHost.warn ? callToActionPastUnsignedContractsDualData.dataValueStyle.Zero : callToActionPastUnsignedContractsDualData.dataValueStyle.None"
                [iconB]="callToActionPastUnsignedContractsDualData.dataIcon.Office"
                (valueBClick)="callToActionPastUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (callToActionPastUnsignedContractsServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionPastUnsignedContractsServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionPastUnsignedContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionPastUnsignedContractsDetailDialog
              [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar caducados'"
              cancelText="Cerrar" [size]="callToActionPastUnsignedContractsDetailDialog.dialogSize.Large">
              @if (callToActionPastUnsignedContractsDetailDialog.visible && callToActionPastUnsignedContractsServiceHost.detailData) {
                <multiview #callToActionPastUnsignedContractsDetailDialogMultiview>
                  <datatable *multiviewContent
                      [columnDefinitions]="callToActionPastUnsignedContractsServiceHost.detailData.columnDefinitions"
                      [data]="callToActionPastUnsignedContractsServiceHost.detailData.tabledata"
                      (onCellAction)="callToActionPastUnsignedContractsServiceHost.handleDatatableCellAction($event, callToActionPastUnsignedContractsDetailDialogMultiview)">
                  </datatable>
                  <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
                  </send-sms>
                  <action-result [data]="data" *multiviewContent="let data=actionResultData">
                  </action-result>
                </multiview>
              }

              @if (callToActionPastUnsignedContractsDetailDialog.visible && callToActionPastUnsignedContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
              </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (callToActionInmediateUnsignedContractsHostVisible) {
        <kpi-host #callToActionInmediateUnsignedContractsHost icon="border_color"
          [title]="'Ctr/pro/fin ctr pdtes firmar hoy y mañana'"
          tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana. Tiene en cuenta los fines de semana"
          [refreshing]="callToActionInmediateUnsignedContractsServiceHost.loading"
          [warn]="callToActionInmediateUnsignedContractsServiceHost.warn"
          [lastUpdatedText]="callToActionInmediateUnsignedContractsServiceHost.lastUpdatedText"
          (detailRequested)="callToActionInmediateUnsignedContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionInmediateUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
          <inmediate-unsigned-contracts-kpi-service-host sink #callToActionInmediateUnsignedContractsServiceHost
              [detailDialog]="callToActionInmediateUnsignedContractsDetailDialog">
          </inmediate-unsigned-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionInmediateUnsignedContractsServiceHost.summaryData && !callToActionInmediateUnsignedContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionInmediateUnsignedContractsServiceHost.summaryData) {
              <dual-data #callToActionInmediateUnsignedContractsDualData
                  [valueA]="callToActionInmediateUnsignedContractsServiceHost.summaryData.consultant"
                  [valueAStyle]="callToActionInmediateUnsignedContractsServiceHost.summaryData.consultant == 0 ? callToActionInmediateUnsignedContractsDualData.dataValueStyle.Zero : callToActionInmediateUnsignedContractsDualData.dataValueStyle.Warn"
                  [iconA]="callToActionInmediateUnsignedContractsDualData.dataIcon.User"
                  (valueAClick)="callToActionInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
                  [valueB]="callToActionInmediateUnsignedContractsServiceHost.summaryData.office"
                  [valueBStyle]="callToActionInmediateUnsignedContractsServiceHost.summaryData.office == 0 ? callToActionInmediateUnsignedContractsDualData.dataValueStyle.Zero : callToActionInmediateUnsignedContractsDualData.dataValueStyle.Warn"
                  [iconB]="callToActionInmediateUnsignedContractsDualData.dataIcon.Office"
                  (valueBClick)="callToActionInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (callToActionInmediateUnsignedContractsServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionInmediateUnsignedContractsServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionInmediateUnsignedContractsServiceHost.refresh()">
            </data-error>
          }
          <modal-dialog detailDialog #callToActionInmediateUnsignedContractsDetailDialog
              [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana'"
              cancelText="Cerrar" [size]="callToActionInmediateUnsignedContractsDetailDialog.dialogSize.Large">
              @if (callToActionInmediateUnsignedContractsDetailDialog.visible && callToActionInmediateUnsignedContractsServiceHost.detailData) {
                <multiview #callToActionInmediateUnsignedContractsDetailDialogMultiview>
                  <datatable *multiviewContent
                    [columnDefinitions]="callToActionInmediateUnsignedContractsServiceHost.detailData.columnDefinitions"
                    [data]="callToActionInmediateUnsignedContractsServiceHost.detailData.tabledata"
                    (onCellAction)="callToActionInmediateUnsignedContractsServiceHost.handleDatatableCellAction($event, callToActionInmediateUnsignedContractsDetailDialogMultiview)">
                  </datatable>
                  <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
                  </send-sms>
                  <action-result [data]="data" *multiviewContent="let data=actionResultData">
                  </action-result>
                </multiview>
              }

              @if (callToActionInmediateUnsignedContractsDetailDialog.visible && callToActionInmediateUnsignedContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (callToActionActiveWorkersWoPPEHostVisible) {
        <kpi-host #callToActionActiveWorkersWoPPEHost [title]="'Trab. activos sin epi'"
          tooltip="Trabajadores activos sin epi: Trabajadores que has quedado con el cliente que vas a entregar epis y no los tienen"
          [refreshing]="callToActionActiveWorkersWoPPEServiceHost.loading"
          [warn]="callToActionActiveWorkersWoPPEServiceHost.warn"
          [lastUpdatedText]="callToActionActiveWorkersWoPPEServiceHost.lastUpdatedText"
          (detailRequested)="callToActionActiveWorkersWoPPEServiceHost.showDetail($event)">
          <i icon class="icon ico-helmet"></i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionActiveWorkersWoPPEServiceHost.refresh()"></kpi-host-menu-option>
          <active-workers-wo-mandatory-ppe-kpi-service-host sink #callToActionActiveWorkersWoPPEServiceHost
              [detailDialog]="callToActionActiveWorkersWoPPEDetailDialog">
          </active-workers-wo-mandatory-ppe-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionActiveWorkersWoPPEServiceHost.summaryData && !callToActionActiveWorkersWoPPEServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionActiveWorkersWoPPEServiceHost.summaryData) {
              <dual-data #callToActionActiveWorkersWoPPEDualData
                  [valueA]="callToActionActiveWorkersWoPPEServiceHost.summaryData.consultant"
                  [valueAStyle]="callToActionActiveWorkersWoPPEServiceHost.summaryData.consultant == 0 ? callToActionActiveWorkersWoPPEDualData.dataValueStyle.Zero : callToActionActiveWorkersWoPPEDualData.dataValueStyle.Warn"
                  [iconA]="callToActionActiveWorkersWoPPEDualData.dataIcon.User"
                  (valueAClick)="callToActionActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: true })"
                  [valueB]="callToActionActiveWorkersWoPPEServiceHost.summaryData.office"
                  [valueBStyle]="callToActionActiveWorkersWoPPEServiceHost.summaryData.office == 0 ? callToActionActiveWorkersWoPPEDualData.dataValueStyle.Zero : callToActionActiveWorkersWoPPEDualData.dataValueStyle.Warn"
                  [iconB]="callToActionActiveWorkersWoPPEDualData.dataIcon.Office"
                  (valueBClick)="callToActionActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (callToActionActiveWorkersWoPPEServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionActiveWorkersWoPPEServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionActiveWorkersWoPPEServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionActiveWorkersWoPPEDetailDialog
              [title]="'Trabajadores activos sin epi'" cancelText="Cerrar"
              [size]="callToActionActiveWorkersWoPPEDetailDialog.dialogSize.Large">
              @if (callToActionActiveWorkersWoPPEDetailDialog.visible && callToActionActiveWorkersWoPPEServiceHost.detailData) {
                <datatable
                  [columnDefinitions]="callToActionActiveWorkersWoPPEServiceHost.detailData.columnDefinitions"
                  [data]="callToActionActiveWorkersWoPPEServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (callToActionActiveWorkersWoPPEDetailDialog.visible && callToActionActiveWorkersWoPPEServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (callToActionInmediateExpiringContractsHostVisible) {
        <kpi-host #callToActionInmediateExpiringContractsHost [title]="'Vtos. contratos hoy y semana'"
          tooltip="Contratos activos con fecha fin prevista de finalización 7 días"
          [refreshing]="callToActionInmediateExpiringContractsServiceHost.loading"
          [warn]="callToActionInmediateExpiringContractsServiceHost.warn"
          [lastUpdatedText]="callToActionInmediateExpiringContractsServiceHost.lastUpdatedText"
          (detailRequested)="callToActionInmediateExpiringContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">date_range</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionInmediateExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
          <inmediate-expiring-contracts-kpi-service-host sink #callToActionInmediateExpiringContractsServiceHost
              [detailDialog]="callToActionInmediateExpiringContractsDetailDialog">
          </inmediate-expiring-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionInmediateExpiringContractsServiceHost.summaryData && !callToActionInmediateExpiringContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionInmediateExpiringContractsServiceHost.summaryData) {
              <dual-data #callToActionInmediateExpiringContractsDualData
                  [valueA]="callToActionInmediateExpiringContractsServiceHost.summaryData.consultant"
                  [iconA]="callToActionInmediateExpiringContractsDualData.dataIcon.User"
                  (valueAClick)="callToActionInmediateExpiringContractsServiceHost.mergeFilter({ consultant: true })"
                  [valueB]="callToActionInmediateExpiringContractsServiceHost.summaryData.office"
                  [iconB]="callToActionInmediateExpiringContractsDualData.dataIcon.Office"
                  (valueBClick)="callToActionInmediateExpiringContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (callToActionInmediateExpiringContractsServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="callToActionInmediateExpiringContractsServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionInmediateExpiringContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionInmediateExpiringContractsDetailDialog
              [title]="'Vencimiento de contratos hoy y semana'" cancelText="Cerrar"
              [size]="callToActionInmediateExpiringContractsDetailDialog.dialogSize.Large">
              @if (callToActionInmediateExpiringContractsDetailDialog.visible && callToActionInmediateExpiringContractsServiceHost.detailData) {
                <datatable [columnDefinitions]="callToActionInmediateExpiringContractsServiceHost.detailData.columnDefinitions"
                  [data]="callToActionInmediateExpiringContractsServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (callToActionInmediateExpiringContractsDetailDialog.visible && callToActionInmediateExpiringContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
              </div>
              }
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #callToActionMessagesGroup [title]="'Mensajes'" [subtitle]="dashboardOwner"
      [hidden]="!callToActionMonthlyTargetsServiceHost.enabled">
      <kpi-group-row>
          <kpi-host #callToActionMonthlyTargetsHost [title]="'Objetivos del mes'"
              [refreshing]="callToActionMonthlyTargetsServiceHost.loading"
              [lastUpdatedText]="callToActionMonthlyTargetsServiceHost.lastUpdatedText" [size]="2"
              [isMoreHost]="true">
              <i icon class="material-icons">notifications</i>
              <monthly-targets-kpi-service-host sink #callToActionMonthlyTargetsServiceHost>
              </monthly-targets-kpi-service-host>
              <ng-container mainData>
                @if (callToActionMonthlyTargetsServiceHost.summaryData) {
                  <ul style="display:flex; flex-flow: column wrap; height: 120px; margin-top: -30px; list-style-type:disc; padding: 0 10px 0 15px; line-height: 20px;">
                    @for (item of callToActionMonthlyTargetsServiceHost.summaryData.goals; track $index) {
                      <li>{{item}}</li>
                    }
                  </ul>
                }
              </ng-container>
          </kpi-host>
      </kpi-group-row>
  </kpi-group>
</kpi-tab-content>

<kpi-tab-content #clientsTab [tabIndex]="1">
  <kpi-group #clientsAttractionGroup [title]="'Atracción'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (clientsVisitsCallsEvolutionHostVisible) {
        <kpi-host #clientsVisitsCallsEvolutionHost [title]="'Visitas - evolución'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza todos los días a las 7 am de cada día"
            [refreshing]="clientsVisitsCallsEvolutionServiceHost.loading"
            [warn]="clientsVisitsCallsEvolutionServiceHost.warn"
            [lastUpdatedText]="clientsVisitsCallsEvolutionServiceHost.lastUpdatedText" [size]="2"
            [hostsBarChart]="true">
            <i icon class="material-icons">work</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsVisitsCallsEvolutionServiceHost.refresh()"></kpi-host-menu-option>
            <visits-calls-evolution-kpi-service-host sink #clientsVisitsCallsEvolutionServiceHost
                [messageDialog]="clientsVisitsCallsEvolutionMessageDialog">
            </visits-calls-evolution-kpi-service-host>
            <ng-container additionalData>
              @if (!clientsVisitsCallsEvolutionServiceHost.summaryData && !clientsVisitsCallsEvolutionServiceHost.summaryError) {
                <no-data></no-data>
              }

              <chart-dropdown #clientsVisitsCallsEvolutionSelector
                  [hidden]="!clientsVisitsCallsEvolutionServiceHost.summaryData"
                  [options]="clientsVisitsCallsEvolutionServiceHost.summaryData">
              </chart-dropdown>

              @if (clientsVisitsCallsEvolutionServiceHost.summaryData) {
                <bar-chart [data]="clientsVisitsCallsEvolutionSelector.selectedOption.value.barChartData"
                  [isVisible]="clientsTab.isVisible">
                </bar-chart>
              }
            </ng-container>

            @if (clientsVisitsCallsEvolutionServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsVisitsCallsEvolutionServiceHost.summaryError.message"
                (onRequestRefresh)="clientsVisitsCallsEvolutionServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsVisitsCallsEvolutionMessageDialog [title]="''" cancelText="Cerrar"
              [size]="clientsVisitsCallsEvolutionMessageDialog.dialogSize.Small">
              <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                  todos los días a las 7 am</p>
            </modal-dialog>
        </kpi-host>
      }

      @if (clientsVisitsPerformedHostVisible) {
        <kpi-host #clientsVisitsPerformedHost [title]="'Visitas realizadas semana'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza todos los días a las 7 am de cada día"
            [refreshing]="clientsVisitsPerformedServiceHost.loading" [warn]="clientsVisitsPerformedServiceHost.warn"
            [lastUpdatedText]="clientsVisitsPerformedServiceHost.lastUpdatedText"
            (detailRequested)="clientsVisitsPerformedServiceHost.showDetail($event)">
            <i icon class="material-icons">work</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsVisitsPerformedServiceHost.refresh()"></kpi-host-menu-option>
            <visits-target-kpi-service-host sink #clientsVisitsPerformedServiceHost
                [detailDialog]="clientsVisitsPerformedDetailDialog"
                [messageDialog]="clientsVisitsPerformedMessageDialog">
            </visits-target-kpi-service-host>
            <ng-container mainData>
              @if (!clientsVisitsPerformedServiceHost.summaryData && !clientsVisitsPerformedServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsVisitsPerformedServiceHost.summaryData) {
                <single-data #clientsVisitsPerformedSingleData [value]="clientsVisitsPerformedServiceHost.summaryData.visits"
                  subValue="de {{clientsVisitsPerformedServiceHost.summaryData.target}}"
                  [icon]="clientsVisitsPerformedSingleData.dataIcon.User">
                </single-data>
              }
            </ng-container>
            @if (clientsVisitsPerformedServiceHost.summaryData) {
              <progress-bar additionalData [value]="clientsVisitsPerformedServiceHost.summaryData.progress"
                text="{{clientsVisitsPerformedServiceHost.summaryData.progress.toFixed(1)}}%"></progress-bar>
            }

            @if (clientsVisitsPerformedServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsVisitsPerformedServiceHost.summaryError.message"
                (onRequestRefresh)="clientsVisitsPerformedServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsVisitsPerformedDetailDialog
                [title]="'Visitas realizadas esta semana'" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDetailDialog.dialogSize.Large">
                @if (clientsVisitsPerformedDetailDialog.visible && clientsVisitsPerformedServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsVisitsPerformedServiceHost.detailData.columnDefinitions"
                    [data]="clientsVisitsPerformedServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsVisitsPerformedDetailDialog.visible && clientsVisitsPerformedServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #clientsVisitsPerformedMessageDialog [title]="''" cancelText="Cerrar"
                [size]="clientsVisitsPerformedMessageDialog.dialogSize.Small">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                    todos los días a las 7 am</p>
            </modal-dialog>
        </kpi-host>
      }

      @if (clientsVisitsPerformedDOHostVisible) {
        <kpi-host #clientsVisitsPerformedDOHost [title]="'Visitas realizadas semana'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza todos los días a las 7 am de cada día"
            [refreshing]="clientsVisitsPerformedDOServiceHost.loading"
            [warn]="clientsVisitsPerformedDOServiceHost.warn"
            [lastUpdatedText]="clientsVisitsPerformedDOServiceHost.lastUpdatedText"
            (detailRequested)="clientsVisitsPerformedDOServiceHost.showDetail($event)">
            <i icon class="material-icons">work</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsVisitsPerformedDOServiceHost.refresh()"></kpi-host-menu-option>
            <visits-target-do-kpi-service-host sink #clientsVisitsPerformedDOServiceHost
                [detailDialog]="clientsVisitsPerformedDODetailDialog"
                [messageDialog]="clientsVisitsPerformedDOMessageDialog">
            </visits-target-do-kpi-service-host>
            <ng-container mainData>
              @if (!clientsVisitsPerformedDOServiceHost.summaryData && !clientsVisitsPerformedDOServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsVisitsPerformedDOServiceHost.summaryData) {
                <dual-data #clientsVisitsPerformedDODualData [valueA]="clientsVisitsPerformedDOServiceHost.summaryData.visits"
                  footerA="de {{clientsVisitsPerformedDOServiceHost.summaryData.target}}"
                  [iconA]="clientsVisitsPerformedDODualData.dataIcon.User"
                  (valueAClick)="clientsVisitsPerformedDOServiceHost.mergeFilter({ wholeOffice: false })"
                  [valueB]="clientsVisitsPerformedDOServiceHost.summaryData.globalVisits"
                  footerB="de {{clientsVisitsPerformedDOServiceHost.summaryData.globalTarget}}"
                  [iconB]="clientsVisitsPerformedDODualData.dataIcon.Office"
                  (valueBClick)="clientsVisitsPerformedDOServiceHost.mergeFilter({ wholeOffice: true })">
                </dual-data>
              }
            </ng-container>
            @if (clientsVisitsPerformedDOServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsVisitsPerformedDOServiceHost.summaryError.message"
                (onRequestRefresh)="clientsVisitsPerformedDOServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsVisitsPerformedDODetailDialog
                [title]="'Visitas realizadas esta semana'" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDODetailDialog.dialogSize.Large">
                @if (clientsVisitsPerformedDODetailDialog.visible && clientsVisitsPerformedDOServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsVisitsPerformedDOServiceHost.detailData.columnDefinitions"
                    [data]="clientsVisitsPerformedDOServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsVisitsPerformedDODetailDialog.visible && clientsVisitsPerformedDOServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #clientsVisitsPerformedDOMessageDialog [title]="" cancelText="Cerrar"
                [size]="clientsVisitsPerformedDOMessageDialog.dialogSize.Large">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                    todos los días a las 7 am</p>

            </modal-dialog>
        </kpi-host>
      }

      @if (clientsOfferingsPerformedHostVisible) {
       <kpi-host #clientsOfferingsPerformedHost [title]="'Ofrecimientos realizados'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas"
            [refreshing]="clientsOfferingsPerformedServiceHost.loading"
            [warn]="clientsOfferingsPerformedServiceHost.warn"
            [lastUpdatedText]="clientsOfferingsPerformedServiceHost.lastUpdatedText"
            (detailRequested)="clientsOfferingsPerformedServiceHost.showDetail($event)">
            <i icon class="material-icons">phone</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsOfferingsPerformedServiceHost.refresh()"></kpi-host-menu-option>
            <offerings-kpi-service-host sink #clientsOfferingsPerformedServiceHost
                [detailDialog]="clientsOfferingsPerformedDetailDialog"
                [messageDialog]="clientsOfferingsMessageDialog">
            </offerings-kpi-service-host>
            <ng-container mainData>
              @if (!clientsOfferingsPerformedServiceHost.summaryData && !clientsOfferingsPerformedServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsOfferingsPerformedServiceHost.summaryData) {
                <single-data #clientsOfferingsPerformedSingleData
                    [value]="clientsOfferingsPerformedServiceHost.summaryData.consultant"
                    subValue="de {{clientsOfferingsPerformedServiceHost.summaryData.target}}"
                    [icon]="clientsOfferingsPerformedSingleData.dataIcon.User">
                </single-data>
              }
            </ng-container>
            @if (clientsOfferingsPerformedServiceHost.summaryData) {
              <progress-bar additionalData [value]="clientsOfferingsPerformedServiceHost.summaryData.progress"
                text="{{clientsOfferingsPerformedServiceHost.summaryData.progress.toFixed(1)}}%"></progress-bar>
            }

            @if (clientsOfferingsPerformedServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsOfferingsPerformedServiceHost.summaryError.message"
                (onRequestRefresh)="clientsOfferingsPerformedServiceHost.refresh()">
            </data-error>
            }

            <modal-dialog detailDialog #clientsOfferingsPerformedDetailDialog [title]="'Ofrecimientos realizados'"
                cancelText="Cerrar" [size]="clientsOfferingsPerformedDetailDialog.dialogSize.Large">
                @if (clientsOfferingsPerformedDetailDialog.visible && clientsOfferingsPerformedServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsOfferingsPerformedServiceHost.detailData.columnDefinitions"
                    [data]="clientsOfferingsPerformedServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsOfferingsPerformedDetailDialog.visible && clientsOfferingsPerformedServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #clientsOfferingsMessageDialog cancelText="Cerrar" [title]="''"
                [size]="clientsOfferingsMessageDialog.dialogSize.Small">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas</p>
            </modal-dialog>
        </kpi-host>
      }

      @if (clientsOfferingsPerformedDOHostVisible) {
        <kpi-host #clientsOfferingsPerformedDOHost [title]="'Ofrecimientos realizados'"
            tooltip="La información se actualiza cada 2 horas desde las 7 a las 21 horas"
            [refreshing]="clientsOfferingsPerformedDOServiceHost.loading"
            [warn]="clientsOfferingsPerformedDOServiceHost.warn"
            [lastUpdatedText]="clientsOfferingsPerformedDOServiceHost.lastUpdatedText"
            (detailRequested)="clientsOfferingsPerformedDOServiceHost.showDetail($event)">
            <i icon class="material-icons">phone</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="clientsOfferingsPerformedDOServiceHost.refresh()"></kpi-host-menu-option>
            <offerings-do-kpi-service-host sink #clientsOfferingsPerformedDOServiceHost
                [detailDialog]="clientsOfferingsPerformedDetailDialog"
                [messageDialog]="clientsOfferingsMessageDialog">
            </offerings-do-kpi-service-host>
            <ng-container mainData>
              @if (!clientsOfferingsPerformedDOServiceHost.summaryData && !clientsOfferingsPerformedDOServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (clientsOfferingsPerformedDOServiceHost.summaryData) {
                <dual-data #clientsOfferingsPerformedSingleData
                    [valueA]="clientsOfferingsPerformedDOServiceHost.summaryData.consultant"
                    footerA="de {{clientsOfferingsPerformedDOServiceHost.summaryData.target}}"
                    (valueAClick)="clientsOfferingsPerformedDOServiceHost.mergeFilter({ consultant: true })"
                    [iconA]="clientsOfferingsPerformedSingleData.dataIcon.User"
                    [valueB]="clientsOfferingsPerformedDOServiceHost.summaryData.office"
                    [iconB]="clientsOfferingsPerformedSingleData.dataIcon.Office"
                    (valueBClick)="clientsOfferingsPerformedDOServiceHost.mergeFilter({ consultant: false })">
                </dual-data>
              }
            </ng-container>
            @if (clientsOfferingsPerformedDOServiceHost.summaryError) {
              <data-error errorMsg [errorMessage]="clientsOfferingsPerformedDOServiceHost.summaryError.message"
                (onRequestRefresh)="clientsOfferingsPerformedDOServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #clientsOfferingsPerformedDetailDialog [title]="'Ofrecimientos realizados'"
                cancelText="Cerrar" [size]="clientsOfferingsPerformedDetailDialog.dialogSize.Large">
                @if (clientsOfferingsPerformedDetailDialog.visible && clientsOfferingsPerformedDOServiceHost.detailData) {
                  <datatable [columnDefinitions]="clientsOfferingsPerformedDOServiceHost.detailData.columnDefinitions"
                    [data]="clientsOfferingsPerformedDOServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (clientsOfferingsPerformedDetailDialog.visible && clientsOfferingsPerformedDOServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #clientsOfferingsMessageDialog cancelText="Cerrar" [title]="''"
                [size]="clientsOfferingsMessageDialog.dialogSize.Small">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas</p>
            </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
    <kpi-group-row>
      @if (clientsOffersInNegotiationExtendedHostVisible) {
        <kpi-host #clientsOffersInNegotiationExtendedHost [title]="'Ofertas + 30d negociación'"
          tooltip="Ofertas + 30d negociación: No se muestran GGCC ni S5. Tendrás la información actualizada cada 4 horas"
          [refreshing]="clientsOffersInNegotiationExtendedServiceHost.loading"
          [warn]="clientsOffersInNegotiationExtendedServiceHost.warn"
          [lastUpdatedText]="clientsOffersInNegotiationExtendedServiceHost.lastUpdatedText" [size]="2"
          [hostsMultiProgress]="true"
          (detailRequested)="clientsOffersInNegotiationExtendedServiceHost.showDetail($event)">
          <i icon class="material-icons">assignment</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="clientsOffersInNegotiationExtendedServiceHost.refresh()"></kpi-host-menu-option>
          <offers-in-negotiation-extended-kpi-service-host sink #clientsOffersInNegotiationExtendedServiceHost
              [detailDialog]="clientsOffersInNegotiationExtendedDetailDialog"
              [messageDialog]="clientsOffersInNegotiationExtendedMessageDialog">

          </offers-in-negotiation-extended-kpi-service-host>
          <ng-container mainData>
            @if (!clientsOffersInNegotiationExtendedServiceHost.summaryData && !clientsOffersInNegotiationExtendedServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (clientsOffersInNegotiationExtendedServiceHost.summaryData) {
              <single-data #clientsOffersInNegotiationExtendedSingleData
                  [value]="clientsOffersInNegotiationExtendedServiceHost.summaryData.offerCount"
                  [icon]="clientsOffersInNegotiationExtendedSingleData.dataIcon.User"
                  [valueStyle]="clientsOffersInNegotiationExtendedServiceHost.summaryData.offerCount>0 ? clientsOffersInNegotiationExtendedSingleData.dataValueStyle.Warn : clientsOffersInNegotiationExtendedSingleData.dataValueStyle.Zero">
              </single-data>
            }
          </ng-container>
          @if (clientsOffersInNegotiationExtendedServiceHost.summaryData) {
            <multi-progress additionalData
              [data]="clientsOffersInNegotiationExtendedServiceHost.summaryData.multiProgressData"
              (click)="clientsOffersInNegotiationExtendedServiceHost.showDetail($event)">
            </multi-progress>
          }

          @if (clientsOffersInNegotiationExtendedServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="clientsOffersInNegotiationExtendedServiceHost.summaryError.message"
              (onRequestRefresh)="clientsOffersInNegotiationExtendedServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #clientsOffersInNegotiationExtendedDetailDialog
              [title]="'Ofertas + 30d negociación'" cancelText="Cerrar"
              [size]="clientsOffersInNegotiationExtendedDetailDialog.dialogSize.Large">
              @if (clientsOffersInNegotiationExtendedDetailDialog.visible && clientsOffersInNegotiationExtendedServiceHost.detailData) {
                <datatable [columnDefinitions]="clientsOffersInNegotiationExtendedServiceHost.detailData.columnDefinitions"
                  [data]="clientsOffersInNegotiationExtendedServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (clientsOffersInNegotiationExtendedDetailDialog.visible && clientsOffersInNegotiationExtendedServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
          <modal-dialog detailDialog #clientsOffersInNegotiationExtendedMessageDialog [title]="''"
              cancelText="Cerrar" [size]="clientsOffersInNegotiationExtendedMessageDialog.dialogSize.Small">
              <p>La información se actualiza cada 4 horas</p>
          </modal-dialog>
        </kpi-host>
      }

      @if (clientsOffersInNegotiationEvolutionDOHostVisible) {
        <kpi-host #clientsOffersInNegotiationEvolutionDOHost
          [title]="'Ofertas + 30d negociación'"
          tooltip="Ofertas + 30d negociación: No se muestran GGCC ni S5. Tendrás la información actualizada cada 4 horas"
          [refreshing]="clientsOffersInNegotiationEvolutionDOServiceHost.loading"
          [warn]="clientsOffersInNegotiationEvolutionDOServiceHost.warn"
          [lastUpdatedText]="clientsOffersInNegotiationEvolutionDOServiceHost.lastUpdatedText" [size]="2"
          [hostsBarChart]="true">
          <i icon class="material-icons">assignment</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="clientsOffersInNegotiationEvolutionDOServiceHost.refresh()"></kpi-host-menu-option>
          <offers-in-negotiation-evolution-do-kpi-service-host sink
              #clientsOffersInNegotiationEvolutionDOServiceHost
              [detailDialog]="clientsOffersInNegotiationEvolutionDODetailDialog"
              [messageDialog]="clientsOffersInNegotiationEvolutionDOMessageDialog">

          </offers-in-negotiation-evolution-do-kpi-service-host>
          <ng-container additionalData>
            @if (!clientsOffersInNegotiationEvolutionDOServiceHost.summaryData && !clientsOffersInNegotiationEvolutionDOServiceHost.summaryError) {
              <no-data></no-data>
            }

            <chart-dropdown #clientsOffersInNegotiationEvolutionDOSelector
                [hidden]="!clientsOffersInNegotiationEvolutionDOServiceHost.summaryData"
                [options]="clientsOffersInNegotiationEvolutionDOServiceHost.summaryData">
            </chart-dropdown>

            @if (clientsOffersInNegotiationEvolutionDOServiceHost.summaryData) {
              <bar-chart [data]="clientsOffersInNegotiationEvolutionDOSelector.selectedOption.value.barChartData"
                  [isVisible]="clientsTab.isVisible">
              </bar-chart>
            }
          </ng-container>
          @if (clientsOffersInNegotiationEvolutionDOServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="clientsOffersInNegotiationEvolutionDOServiceHost.summaryError.message"
              (onRequestRefresh)="clientsOffersInNegotiationEvolutionDOServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #clientsOffersInNegotiationEvolutionDODetailDialog
              [title]="'Ofertas + 30d negociación'" cancelText="Cerrar"
              [size]="clientsOffersInNegotiationEvolutionDODetailDialog.dialogSize.Large">
              @if (clientsOffersInNegotiationEvolutionDODetailDialog.visible && clientsOffersInNegotiationEvolutionDOServiceHost.detailData) {
                <datatable [columnDefinitions]="clientsOffersInNegotiationEvolutionDOServiceHost.detailData.columnDefinitions"
                  [data]="clientsOffersInNegotiationEvolutionDOServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (clientsOffersInNegotiationEvolutionDODetailDialog.visible && clientsOffersInNegotiationEvolutionDOServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
              </div>
              }
          </modal-dialog>
          <modal-dialog detailDialog #clientsOffersInNegotiationEvolutionDOMessageDialog [title]="''"
              cancelText="Cerrar" [size]="clientsOffersInNegotiationEvolutionDOMessageDialog.dialogSize.Small">
              <p>La información se actualiza cada 4 horas</p>
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #clientsLoyaltyGroup [title]="'Fidelización'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (clientsPastExpiringOrdersHostVisible) {
        <kpi-host #clientsPastExpiringOrdersHost
          [title]="'Peticiones vencidas'" [refreshing]="clientsPastExpiringOrdersServiceHost.loading"
          [warn]="clientsPastExpiringOrdersServiceHost.warn"
          [lastUpdatedText]="clientsPastExpiringOrdersServiceHost.lastUpdatedText" [size]="2" [isTwoColumn]="true"
          [hostsMultiProgress]="true" (detailRequested)="clientsPastExpiringOrdersServiceHost.showDetail($event)">
          <i icon class="material-icons">shopping_cart</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="clientsPastExpiringOrdersServiceHost.refresh()"></kpi-host-menu-option>
          <past-pending-orders-extended-kpi-service-host sink #clientsPastExpiringOrdersServiceHost>
          </past-pending-orders-extended-kpi-service-host>
          <ng-container mainData>
            @if (!clientsPastExpiringOrdersServiceHost.summaryData && !clientsPastExpiringOrdersServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (clientsPastExpiringOrdersServiceHost.summaryData) {
              <dual-data #clientsPastExpiringOrdersDualData
                [valueA]="clientsPastExpiringOrdersServiceHost.summaryData.consultantTotal"
                [valueAStyle]="clientsPastExpiringOrdersServiceHost.summaryData.consultantTotal == 0 ? clientsPastExpiringOrdersDualData.dataValueStyle.Zero : clientsPastExpiringOrdersDualData.dataValueStyle.None"
                footerA="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantBuckets}} de buckets"
                [footerAStyle]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBuckets == 0 ? clientsPastExpiringOrdersDualData.dataValueStyle.None : clientsPastExpiringOrdersDualData.dataValueStyle.Warn"
                [iconA]="clientsPastExpiringOrdersDualData.dataIcon.User"
                [valueB]="clientsPastExpiringOrdersServiceHost.summaryData.officeTotal"
                [valueBStyle]="clientsPastExpiringOrdersServiceHost.summaryData.officeTotal == 0 ? clientsPastExpiringOrdersDualData.dataValueStyle.Zero : clientsPastExpiringOrdersDualData.dataValueStyle.None"
                footerB="{{clientsPastExpiringOrdersServiceHost.summaryData.officeBuckets}} de buckets"
                [footerBStyle]="clientsPastExpiringOrdersServiceHost.summaryData.officeBuckets == 0 ? clientsPastExpiringOrdersDualData.dataValueStyle.None : clientsPastExpiringOrdersDualData.dataValueStyle.Warn"
                [iconB]="clientsPastExpiringOrdersDualData.dataIcon.Office">
              </dual-data>
            }
          </ng-container>
          @if (clientsPastExpiringOrdersServiceHost.summaryData) {
            <div additionalData class="wrapper-multi-progress multi-progress_50">
              <div class="multi-progress">
                  <span class="title-progress">Buckets</span>
                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Consultor</span>
                      <div class="progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent == 0) {
                          <div class="progress-bar bg-empty"
                            role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                            0
                          </div>

                          <div class="progress-bar bg-empty"
                            role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                            0
                          </div>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent != 0) {
                          <div class="progress-bar bg-alert"
                              role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA}}
                          </div>

                          <div class="progress-bar bg-alert2"
                              role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) < 0.32"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'">T.
                            temporal</span>

                            <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) < 0.2"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Oficina</span>
                      <div class="progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent == 0) {
                          <div class="progress-bar bg-empty"
                              role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>

                          <div class="progress-bar bg-empty"
                              role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent != 0) {
                          <div class="progress-bar bg-alert"
                              role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA}}
                          </div>
                          <div class="progress-bar bg-alert2"
                              role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) < 0.32"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'">T.
                              temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) < 0.2"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

              </div>
              <div class="multi-progress">
                  <span class="title-progress">No Buckets</span>
                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Consultor</span>
                      <div class="progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent == 0) {
                          <div class="progress-bar"
                            role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                              0
                          </div>
                          <div class="progress-bar bg-warning"
                            role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent != 0) {
                          <div class="progress-bar" role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA}}
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) < 0.32"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) < 0.2"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Oficina</span>
                      <div class="progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent == 0) {
                          <div class="progress-bar" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                            0
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent != 0) {
                          <div class="progress-bar" role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA}}
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar"
                              [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}">
                              {{clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) < 0.32"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) < 0.2"
                            [style.width]="clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsPastExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

              </div>
            </div>
          }
          @if (clientsPastExpiringOrdersServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="clientsPastExpiringOrdersServiceHost.summaryError.message"
              (onRequestRefresh)="clientsPastExpiringOrdersServiceHost.refresh()">
          </data-error>
          }
        </kpi-host>
      }

      @if (clientsInmediateExpiringOrdersHostVisible) {
        <kpi-host #clientsInmediateExpiringOrdersHost
          [title]="'Peticiones pendientes'" [refreshing]="clientsInmediateExpiringOrdersServiceHost.loading"
          [warn]="clientsInmediateExpiringOrdersServiceHost.warn"
          [lastUpdatedText]="clientsInmediateExpiringOrdersServiceHost.lastUpdatedText" [size]="2"
          [isTwoColumn]="true" [hostsMultiProgress]="true"
          (detailRequested)="clientsInmediateExpiringOrdersServiceHost.showDetail($event)">
          <i icon class="material-icons">shopping_cart</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="clientsInmediateExpiringOrdersServiceHost.refresh()"></kpi-host-menu-option>
          <inmediate-pending-orders-extended-kpi-service-host sink #clientsInmediateExpiringOrdersServiceHost>
          </inmediate-pending-orders-extended-kpi-service-host>
          <ng-container mainData>
            @if (!clientsInmediateExpiringOrdersServiceHost.summaryData && !clientsInmediateExpiringOrdersServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (clientsInmediateExpiringOrdersServiceHost.summaryData) {
              <dual-data #clientsInmediateExpiringOrdersDualData
                [valueA]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantTotal"
                [valueAStyle]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantTotal == 0 ? clientsInmediateExpiringOrdersDualData.dataValueStyle.Zero : clientsInmediateExpiringOrdersDualData.dataValueStyle.None"
                footerA="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBuckets}} de buckets"
                [footerAStyle]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBuckets == 0 ? clientsInmediateExpiringOrdersDualData.dataValueStyle.None : clientsInmediateExpiringOrdersDualData.dataValueStyle.Warn"
                [iconA]="clientsInmediateExpiringOrdersDualData.dataIcon.User"
                [valueB]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeTotal"
                [valueBStyle]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeTotal == 0 ? clientsInmediateExpiringOrdersDualData.dataValueStyle.Zero : clientsInmediateExpiringOrdersDualData.dataValueStyle.None"
                footerB="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBuckets}} de buckets"
                [footerBStyle]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBuckets == 0 ? clientsInmediateExpiringOrdersDualData.dataValueStyle.None : clientsInmediateExpiringOrdersDualData.dataValueStyle.Warn"
                [iconB]="clientsInmediateExpiringOrdersDualData.dataIcon.Office">
              </dual-data>
            }
          </ng-container>
          @if (clientsInmediateExpiringOrdersServiceHost.summaryData) {
            <div additionalData class="wrapper-multi-progress multi-progress_50">
              <div class="multi-progress">
                  <span class="title-progress">Buckets</span>
                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Consultor</span>
                      <div class="progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent == 0) {
                          <div class="progress-bar bg-empty" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                            0
                          </div>
                          <div class="progress-bar bg-empty" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                            aria-valuemax="100">
                            0
                          </div>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent != 0) {
                          <div class="progress-bar bg-alert" role="progressbar"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'"
                            attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA}}"
                            aria-valuemin="0"
                            attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}">
                            {{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA}}
                          </div>
                          <div class="progress-bar bg-alert2" role="progressbar"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'"
                            attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}"
                            aria-valuemin="0"
                            attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}">
                            {{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) < 0.32"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) < 0.2"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Oficina</span>
                      <div class="progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent == 0) {
                          <div class="progress-bar bg-empty" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                          <div class="progress-bar bg-empty" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent != 0) {
                          <div class="progress-bar bg-alert" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA}}
                          </div>
                          <div class="progress-bar bg-alert2" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) < 0.32"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) < 0.2"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

              </div>
              <div class="multi-progress">
                  <span class="title-progress">No Buckets</span>
                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Consultor</span>
                      <div class="progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent == 0) {
                          <div class="progress-bar" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent != 0) {
                          <div class="progress-bar" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA}}
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) < 0.32"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) < 0.2"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.consultantNoBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

                  <div class="wrapper-progress">
                      <span class="legend-top-progress">Oficina</span>
                      <div class="progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent == 0) {
                          <div class="progress-bar" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar" [style.width]="'50%'" aria-valuenow="50" aria-valuemin="0"
                              aria-valuemax="100">
                              0
                          </div>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent != 0) {
                          <div class="progress-bar" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA}}
                          </div>
                          <div class="progress-bar bg-warning" role="progressbar"
                              [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'"
                              attr.aria-valuenow="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}"
                              aria-valuemin="0"
                              attr.aria-valuemax="{{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}">
                              {{clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent}}
                          </div>
                        }
                      </div>
                      <div class="legend-bottom-progress">
                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent == 0) {
                          <span [style.width]="'50%'">T. temporal</span>
                          <span [style.width]="'50%'">Perm</span>
                        }

                        @if (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent != 0) {
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) < 0.32"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'">T.
                            temporal</span>
                          <span style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                            [hidden]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) < 0.2"
                            [style.width]="clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent / (clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketTEA + clientsInmediateExpiringOrdersServiceHost.summaryData.officeNoBucketPermanent) * 100 + '%'">Perm</span>
                        }
                      </div>
                  </div>

              </div>
            </div>
          }
          @if (clientsInmediateExpiringOrdersServiceHost.summaryError) {
             <data-error errorMsg
              [errorMessage]="clientsInmediateExpiringOrdersServiceHost.summaryError.message"
              (onRequestRefresh)="clientsInmediateExpiringOrdersServiceHost.refresh()">
          </data-error>
          }
        </kpi-host>
      }
    </kpi-group-row>

    <kpi-group-row>
      @if (callToActionPendingOrderFDVisible) {
        <kpi-host #callToActionPendingOrderFD
          [title]="'Pedidos FD pdte completar proceso'"
          tooltip="Total de pedidos FD pdtes de realizar algún proceso (llamamiento, realizar el contrato o buscar mas candidatos)"
          [refreshing]="callToActionPendingOrderFDServiceHost.loading"
          [warn]="callToActionPendingOrderFDServiceHost.warn"
          [lastUpdatedText]="callToActionPendingOrderFDServiceHost.lastUpdatedText"
          (detailRequested)="callToActionPendingOrderFDServiceHost.showDetail($event)">
          <i icon class="material-icons">people</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="callToActionPendingOrderFDServiceHost.refresh()"></kpi-host-menu-option>
          <pending-orders-fd-kpi-service-host sink #callToActionPendingOrderFDServiceHost
              [detailDialog]="callToActionPendingOrderFDDetailDialog"
              [messageDialog]="callToActionPendingOrderFDMessageDialog">
          </pending-orders-fd-kpi-service-host>
          <ng-container mainData>
            @if (!callToActionPendingOrderFDServiceHost.summaryData && !callToActionPendingOrderFDServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (callToActionPendingOrderFDServiceHost.summaryData) {
              <single-data #callToActionPendingOrderFDSingleData
                [value]="callToActionPendingOrderFDServiceHost.summaryData.kpi"
                [valueStyle]="callToActionPendingOrderFDServiceHost.summaryData.kpi == 0 ? callToActionPendingOrderFDSingleData.dataValueStyle.Zero : callToActionPendingOrderFDSingleData.dataValueStyle.Warn"
                [icon]="callToActionPendingOrderFDSingleData.dataIcon.Office">
              </single-data>
            }
          </ng-container>
          @if (callToActionPendingOrderFDServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="callToActionPendingOrderFDServiceHost.summaryError.message"
              (onRequestRefresh)="callToActionPendingOrderFDServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #callToActionPendingOrderFDDetailDialog
              [title]="'Pedidos FD pdte completar proceso'" cancelText="Cerrar"
              [size]="callToActionPendingOrderFDDetailDialog.dialogSize.Large">
              @if (callToActionPendingOrderFDDetailDialog.visible && callToActionPendingOrderFDServiceHost.detailData) {
                <datatable
                  [columnDefinitions]="callToActionPendingOrderFDServiceHost.detailData.columnDefinitions"
                  [data]="callToActionPendingOrderFDServiceHost.detailData.tabledata"
                  [rowStyleSelector]="callToActionPendingOrderFDServiceHost.detailData.rowStyleSelector"
                  [heightHeaderPx]=36>
                </datatable>
              }

              @if (callToActionPendingOrderFDDetailDialog.visible && callToActionPendingOrderFDServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
          <modal-dialog detailDialog #callToActionPendingOrderFDMessageDialog [title]="" cancelText="Cerrar"
              [size]="callToActionPendingOrderFDMessageDialog.dialogSize.Large">
              <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                  todos los días a las 7 am</p>
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #digitalizationGroup [title]="'Digitalización'" [subtitle]="dashboardOwner">
      <kpi-group-row>
        @if (managementControlClientsWoESolutionHostVisible) {
          <kpi-host #managementControlClientsWoESolutionHost
            [title]="'Clientes NO e-solutions'"
            [refreshing]="managementControlClientsWoESolutionServiceHost.loading"
            [warn]="managementControlClientsWoESolutionServiceHost.warn"
            [lastUpdatedText]="managementControlClientsWoESolutionServiceHost.lastUpdatedText"
            (detailRequested)="managementControlClientsWoESolutionServiceHost.showDetail($event)">
            <i icon class="material-icons">people</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="managementControlClientsWoESolutionServiceHost.refresh()"></kpi-host-menu-option>
            <client-wo-esolution-extended-kpi-service-host sink #managementControlClientsWoESolutionServiceHost
                [detailDialog]="managementControlClientsWoESolutionDetailDialog">
            </client-wo-esolution-extended-kpi-service-host>
            <ng-container mainData>
              @if (!managementControlClientsWoESolutionServiceHost.summaryData && !managementControlClientsWoESolutionServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (managementControlClientsWoESolutionServiceHost.summaryData) {
                <single-data #managementControlClientsWoESolutionSingleData
                    [value]="managementControlClientsWoESolutionServiceHost.summaryData.office"
                    [icon]="managementControlClientsWoESolutionSingleData.dataIcon.User">
                </single-data>
              }
            </ng-container>
            @if (managementControlClientsWoESolutionServiceHost.summaryError) {
              <data-error errorMsg
                [errorMessage]="managementControlClientsWoESolutionServiceHost.summaryError.message"
                (onRequestRefresh)="managementControlClientsWoESolutionServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #managementControlClientsWoESolutionDetailDialog
                [title]="'Clientes NO e-solutions'" cancelText="Cerrar"
                [size]="managementControlClientsWoESolutionDetailDialog.dialogSize.Large">
                @if (managementControlClientsWoESolutionDetailDialog.visible && managementControlClientsWoESolutionServiceHost.detailData) {
                  <datatable [columnDefinitions]="managementControlClientsWoESolutionServiceHost.detailData.columnDefinitions"
                    [data]="managementControlClientsWoESolutionServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (managementControlClientsWoESolutionDetailDialog.visible && managementControlClientsWoESolutionServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
          </kpi-host>
        }

        @if (managementControlClientsWoBulletinsHostVisible) {
          <kpi-host #managementControlClientsWoBulletinsHost
            [title]="'Clientes e-solutions sin boletines'"
            [tooltip]="'Clientes de tu base de datos que están dados de alta en e-solutions pero no tienen la funcionalidad de boletines web'"
            [refreshing]="managementControlClientsWoBulletinsServiceHost.loading"
            [warn]="managementControlClientsWoBulletinsServiceHost.warn"
            [lastUpdatedText]="managementControlClientsWoBulletinsServiceHost.lastUpdatedText"
            (detailRequested)="managementControlClientsWoBulletinsServiceHost.showDetail($event)">
            <i icon class="material-icons">people</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="managementControlClientsWoBulletinsServiceHost.refresh()"></kpi-host-menu-option>
            <client-wo-bulletins-extended-kpi-service-host sink #managementControlClientsWoBulletinsServiceHost
                [detailDialog]="managementControlClientsWoBulletinsDetailDialog">
            </client-wo-bulletins-extended-kpi-service-host>
            <ng-container mainData>
              @if (!managementControlClientsWoBulletinsServiceHost.summaryData && !managementControlClientsWoBulletinsServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (managementControlClientsWoBulletinsServiceHost.summaryData) {
                <single-data #managementControlClientsWoBulletinsSingleData
                  [value]="managementControlClientsWoBulletinsServiceHost.summaryData.office"
                  [icon]="managementControlClientsWoBulletinsSingleData.dataIcon.User">
                </single-data>
              }
            </ng-container>
            @if (managementControlClientsWoBulletinsServiceHost.summaryError) {
              <data-error errorMsg
                [errorMessage]="managementControlClientsWoBulletinsServiceHost.summaryError.message"
                (onRequestRefresh)="managementControlClientsWoBulletinsServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #managementControlClientsWoBulletinsDetailDialog
                [title]="'Clientes e-solutions sin boletines'" cancelText="Cerrar"
                [size]="managementControlClientsWoBulletinsDetailDialog.dialogSize.Large">
                @if (managementControlClientsWoBulletinsDetailDialog.visible && managementControlClientsWoBulletinsServiceHost.detailData) {
                  <datatable [columnDefinitions]="managementControlClientsWoBulletinsServiceHost.detailData.columnDefinitions"
                    [data]="managementControlClientsWoBulletinsServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (managementControlClientsWoBulletinsDetailDialog.visible && managementControlClientsWoBulletinsServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                  </div>
                }
            </modal-dialog>
          </kpi-host>
        }
      </kpi-group-row>
  </kpi-group>
</kpi-tab-content>

<kpi-tab-content #talentTab [tabIndex]="2">
  <kpi-group #overviewClientsGroup [title]="'Atracción'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (talentCandidatesBucketStatusDetailHostVisible) {
        <kpi-host #talentCandidatesBucketStatusDetailHost [title]="'Candidatos que me faltan en Focus Talent Groups'"
          [refreshing]="talentCandidatesBucketStatusDetailServiceHost.loading"
          [warn]="talentCandidatesBucketStatusDetailServiceHost.warn"
          [lastUpdatedText]="talentCandidatesBucketStatusDetailServiceHost.lastUpdatedText" [size]="2"
          [hostsDoughnutChart]="true"
          (detailRequested)="talentCandidatesBucketStatusDetailServiceHost.showDetail($event)">
          <i icon class="material-icons">people</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="talentCandidatesBucketStatusDetailServiceHost.refresh()"></kpi-host-menu-option>
          <bucket-status-extended-kpi-service-host sink #talentCandidatesBucketStatusDetailServiceHost>
          </bucket-status-extended-kpi-service-host>
          <ng-container additionalData>
            @if (!talentCandidatesBucketStatusDetailServiceHost.summaryData && !talentCandidatesBucketStatusDetailServiceHost.summaryError) {
              <div style="width: 100%; height: 100%; display: flex; flex-direction: row; align-items:center; flex-wrap: nowrap;">
                <p style="margin-left:auto;">¡Buen trabajo!</p><i class="far fa-thumbs-up"
                    style="margin-left: 5px; margin-right: auto;"></i>
              </div>
            }

            @if (talentCandidatesBucketStatusDetailServiceHost.summaryData) {
              <doughnut-chart #talentCandidatesBucketStatusDetailChart
                [data]="talentCandidatesBucketStatusDetailServiceHost.summaryData.buckets"
                [isVisible]="talentTab.isVisible"
                [totalStyle]="talentCandidatesBucketStatusDetailServiceHost.summaryData.total == 0 ? talentCandidatesBucketStatusDetailChart.dataValueStyle.Zero : talentCandidatesBucketStatusDetailChart.dataValueStyle.Warn">
              </doughnut-chart>
            }
          </ng-container>
          @if (talentCandidatesBucketStatusDetailServiceHost.summaryData) {
            <i additionalData class="icon icon-home"></i>
          }

          @if (talentCandidatesBucketStatusDetailServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="talentCandidatesBucketStatusDetailServiceHost.summaryError.message"
              (onRequestRefresh)="talentCandidatesBucketStatusDetailServiceHost.refresh()">
          </data-error>
          }
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>
  <kpi-group #loyaltyGroup [title]="'Fidelización'" [subtitle]="dashboardOwner">
      <kpi-group-row>
        @if (discontinuousPermanentWorkersHostVisible) {
          <kpi-host #discontinuousPermanentWorkersHost
            [title]="'Trab. fijos discontinuos stand by'"
            tooltip="Trabajadores fijos discontinuos de tu oficina en estado stand by"
            [refreshing]="discontinuousPermanentWorkersServiceHost.loading"
            [warn]="discontinuousPermanentWorkersServiceHost.warn"
            [lastUpdatedText]="discontinuousPermanentWorkersServiceHost.lastUpdatedText"
            (detailRequested)="discontinuousPermanentWorkersServiceHost.showDetail($event)">
            <i icon class="material-icons">people</i>
            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                (click)="discontinuousPermanentWorkersServiceHost.refresh()"></kpi-host-menu-option>
            <discontinuous-permanent-workers-kpi-service-host sink #discontinuousPermanentWorkersServiceHost
                [detailDialog]="discontinuousPermanentWorkersDetailDialog"
                [messageDialog]="discontinuousPermanentWorkersMessageDialog">
            </discontinuous-permanent-workers-kpi-service-host>
            <ng-container mainData>
              @if (!discontinuousPermanentWorkersServiceHost.summaryData && !discontinuousPermanentWorkersServiceHost.summaryError) {
                <no-data></no-data>
              }

              @if (discontinuousPermanentWorkersServiceHost.summaryData) {
                <single-data #discontinuousPermanentWorkersSingleData
                  [value]="discontinuousPermanentWorkersServiceHost.summaryData.consultant"
                  [valueStyle]="discontinuousPermanentWorkersServiceHost.summaryData.consultant == 0 ? discontinuousPermanentWorkersSingleData.dataValueStyle.Zero : discontinuousPermanentWorkersSingleData.dataValueStyle.Warn"
                  [icon]="discontinuousPermanentWorkersSingleData.dataIcon.Office">
                </single-data>
              }
            </ng-container>
            @if (discontinuousPermanentWorkersServiceHost.summaryError) {
              <data-error errorMsg
                [errorMessage]="discontinuousPermanentWorkersServiceHost.summaryError.message"
                (onRequestRefresh)="discontinuousPermanentWorkersServiceHost.refresh()">
              </data-error>
            }

            <modal-dialog detailDialog #discontinuousPermanentWorkersDetailDialog
                [title]="'Trab. fijos discontinuos stand by'" cancelText="Cerrar"
                [size]="discontinuousPermanentWorkersDetailDialog.dialogSize.Large">
                @if (discontinuousPermanentWorkersDetailDialog.visible && discontinuousPermanentWorkersServiceHost.detailData) {
                  <datatable [columnDefinitions]="discontinuousPermanentWorkersServiceHost.detailData.columnDefinitions"
                    [data]="discontinuousPermanentWorkersServiceHost.detailData.tabledata">
                  </datatable>
                }

                @if (discontinuousPermanentWorkersDetailDialog.visible && discontinuousPermanentWorkersServiceHost.detailError) {
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                    <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
                }
            </modal-dialog>
            <modal-dialog detailDialog #discontinuousPermanentWorkersMessageDialog [title]="" cancelText="Cerrar"
                [size]="discontinuousPermanentWorkersMessageDialog.dialogSize.Large">
                <p>La información se actualiza cada 2 horas desde las 7 a las 21 horas. El objetivo se actualiza
                    todos los días a las 7 am</p>

            </modal-dialog>
          </kpi-host>
        }
      </kpi-group-row>
  </kpi-group>
</kpi-tab-content>

<kpi-tab-content #managementControlTab [tabIndex]="3">
  <kpi-group #unsignedContractsGroup [title]="'Firma de contratos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPastUnsignedContractsHostVisible) {
        <kpi-host #managementControlPastUnsignedContractsHost
          [title]="'Ctr/pro/fin ctr pdtes firmar caducados'"
          tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar caducados: Se muestra contratos de máximo 15 dias para atrás"
          [refreshing]="managementControlPastUnsignedContractsServiceHost.loading"
          [warn]="managementControlPastUnsignedContractsServiceHost.warn"
          [lastUpdatedText]="managementControlPastUnsignedContractsServiceHost.lastUpdatedText"
          (detailRequested)="managementControlPastUnsignedContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlPastUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
          <past-unsigned-contracts-kpi-service-host sink #managementControlPastUnsignedContractsServiceHost
              [detailDialog]="managementControlPastUnsignedContractsDetailDialog">
          </past-unsigned-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlPastUnsignedContractsServiceHost.summaryData && !managementControlPastUnsignedContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlPastUnsignedContractsServiceHost.summaryData) {
              <dual-data #managementControlPastUnsignedContractsDualData
                [valueA]="managementControlPastUnsignedContractsServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlPastUnsignedContractsServiceHost.summaryData.consultant == 0 && !managementControlPastUnsignedContractsServiceHost.warn ? managementControlPastUnsignedContractsDualData.dataValueStyle.Zero : managementControlPastUnsignedContractsDualData.dataValueStyle.None"
                [iconA]="managementControlPastUnsignedContractsDualData.dataIcon.User"
                (valueAClick)="managementControlPastUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlPastUnsignedContractsServiceHost.summaryData.office"
                [valueBStyle]="managementControlPastUnsignedContractsServiceHost.summaryData.office == 0 && !managementControlPastUnsignedContractsServiceHost.warn ? managementControlPastUnsignedContractsDualData.dataValueStyle.Zero : managementControlPastUnsignedContractsDualData.dataValueStyle.None"
                [iconB]="managementControlPastUnsignedContractsDualData.dataIcon.Office"
                (valueBClick)="managementControlPastUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlPastUnsignedContractsServiceHost.summaryError) {
            <data-error errorMsg [errorMessage]="managementControlPastUnsignedContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlPastUnsignedContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlPastUnsignedContractsDetailDialog
              [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar caducados'"
              cancelText="Cerrar" [size]="managementControlPastUnsignedContractsDetailDialog.dialogSize.Large">
              @if (managementControlPastUnsignedContractsDetailDialog.visible && managementControlPastUnsignedContractsServiceHost.detailData) {
                <multiview #managementControlPastUnsignedContractsDetailDialogMultiview>
                  <datatable *multiviewContent
                      [columnDefinitions]="managementControlPastUnsignedContractsServiceHost.detailData.columnDefinitions"
                      [data]="managementControlPastUnsignedContractsServiceHost.detailData.tabledata"
                      (onCellAction)="managementControlPastUnsignedContractsServiceHost.handleDatatableCellAction($event, managementControlPastUnsignedContractsDetailDialogMultiview)">
                  </datatable>
                  <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
                  </send-sms>
                  <action-result [data]="data" *multiviewContent="let data=actionResultData">
                  </action-result>
                </multiview>
              }

              @if (managementControlPastUnsignedContractsDetailDialog.visible && managementControlPastUnsignedContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlInmediateUnsignedContractsHostVisible) {
        <kpi-host #managementControlInmediateUnsignedContractsHost
          [title]="'Ctr/pro/fin ctr pdtes firmar hoy y mañana'"
          tooltip="Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana. Tiene en cuenta los fines de semana"
          [refreshing]="managementControlInmediateUnsignedContractsServiceHost.loading"
          [warn]="managementControlInmediateUnsignedContractsServiceHost.warn"
          [lastUpdatedText]="managementControlInmediateUnsignedContractsServiceHost.lastUpdatedText"
          (detailRequested)="managementControlInmediateUnsignedContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlInmediateUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
          <inmediate-unsigned-contracts-kpi-service-host sink
              #managementControlInmediateUnsignedContractsServiceHost
              [detailDialog]="managementControlInmediateUnsignedContractsDetailDialog">
          </inmediate-unsigned-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlInmediateUnsignedContractsServiceHost.summaryData && !managementControlInmediateUnsignedContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlInmediateUnsignedContractsServiceHost.summaryData) {
              <dual-data #managementControlInmediateUnsignedContractsDualData
                [valueA]="managementControlInmediateUnsignedContractsServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlInmediateUnsignedContractsServiceHost.summaryData.consultant == 0 ? managementControlInmediateUnsignedContractsDualData.dataValueStyle.Zero : managementControlInmediateUnsignedContractsDualData.dataValueStyle.Warn"
                [iconA]="managementControlInmediateUnsignedContractsDualData.dataIcon.User"
                (valueAClick)="managementControlInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlInmediateUnsignedContractsServiceHost.summaryData.office"
                [valueBStyle]="managementControlInmediateUnsignedContractsServiceHost.summaryData.office == 0 ? managementControlInmediateUnsignedContractsDualData.dataValueStyle.Zero : managementControlInmediateUnsignedContractsDualData.dataValueStyle.Warn"
                [iconB]="managementControlInmediateUnsignedContractsDualData.dataIcon.Office"
                (valueBClick)="managementControlInmediateUnsignedContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlInmediateUnsignedContractsServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlInmediateUnsignedContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlInmediateUnsignedContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlInmediateUnsignedContractsDetailDialog
              [title]="'Contratos, prórrogas y fin de contratos pendientes de firmar hoy y mañana'"
              cancelText="Cerrar"
              [size]="managementControlInmediateUnsignedContractsDetailDialog.dialogSize.Large">
              @if (managementControlInmediateUnsignedContractsDetailDialog.visible && managementControlInmediateUnsignedContractsServiceHost.detailData) {
                <multiview #managementControlInmediateUnsignedContractsDetailDialogMultiview>
                  <datatable *multiviewContent
                      [columnDefinitions]="managementControlInmediateUnsignedContractsServiceHost.detailData.columnDefinitions"
                      [data]="managementControlInmediateUnsignedContractsServiceHost.detailData.tabledata"
                      (onCellAction)="managementControlInmediateUnsignedContractsServiceHost.handleDatatableCellAction($event, managementControlInmediateUnsignedContractsDetailDialogMultiview)">
                  </datatable>
                  <send-sms [data]="data" *multiviewContent="let data=sendSMSData">
                  </send-sms>
                  <action-result [data]="data" *multiviewContent="let data=actionResultData">
                  </action-result>
                </multiview>
              }

              @if (managementControlInmediateUnsignedContractsDetailDialog.visible && managementControlInmediateUnsignedContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlForecastUnsignedContractsHostVisible) {
        <kpi-host #managementControlForecastUnsignedContractsHost
          [title]="'Contratos pendiente firmar esta semana'" tooltip="Contratos pendientes de firmar esta semana"
          [refreshing]="managementControlForecastUnsignedContractsServiceHost.loading"
          [warn]="managementControlForecastUnsignedContractsServiceHost.warn"
          [lastUpdatedText]="managementControlForecastUnsignedContractsServiceHost.lastUpdatedText" [size]="2"
          [hostsLineChart]="true"
          (detailRequested)="managementControlForecastUnsignedContractsServiceHost.showDetailEx($event, { name: managementControlForecastUnsignedContractsSelector.selectedOption.text });">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlForecastUnsignedContractsServiceHost.refresh()"></kpi-host-menu-option>
          <unsigned-contracts-evolution-kpi-service-host sink
              #managementControlForecastUnsignedContractsServiceHost
              [detailDialog]="managementControlForecastUnsignedContractsDetailDialog">
          </unsigned-contracts-evolution-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlForecastUnsignedContractsServiceHost.summaryData && !managementControlForecastUnsignedContractsServiceHost.summaryError) {
              <no-data></no-data>
            }
          </ng-container>
          <ng-container additionalData>
              <chart-dropdown #managementControlForecastUnsignedContractsSelector
                  [hidden]="!managementControlForecastUnsignedContractsServiceHost.summaryData"
                  [options]="managementControlForecastUnsignedContractsServiceHost.summaryData">
              </chart-dropdown>
              @if (managementControlForecastUnsignedContractsServiceHost.summaryData) {
                <line-chart
                  [data]="managementControlForecastUnsignedContractsSelector.selectedOption.value.lineChartData"
                  [isVisible]="managementControlTab.isVisible"
                  (clickData)="managementControlForecastUnsignedContractsServiceHost.mergeFilter({ date: managementControlForecastUnsignedContractsSelector.selectedOption.value.dates[$event.dataIndices[0]] })">
                </line-chart>
              }
          </ng-container>
          @if (managementControlForecastUnsignedContractsServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlForecastUnsignedContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlForecastUnsignedContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlForecastUnsignedContractsDetailDialog
              [title]="'Contratos pendiente firmar esta semana'" cancelText="Cerrar"
              [size]="managementControlForecastUnsignedContractsDetailDialog.dialogSize.Large">
              @if (managementControlForecastUnsignedContractsDetailDialog.visible && managementControlForecastUnsignedContractsServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlForecastUnsignedContractsServiceHost.detailData.columnDefinitions"
                  [data]="managementControlForecastUnsignedContractsServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlForecastUnsignedContractsDetailDialog.visible && managementControlForecastUnsignedContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #expiringContractsGroup [title]="'Vencimientos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPastExpiringContractsHostVisible) {
          <kpi-host #managementControlPastExpiringContractsHost
          [title]="'Vtos. contratos caducados'"
          tooltip="Vencimientos de contratos caducados: Contratos que no has informado la baja o prórroga (15 días para atrás)"
          [refreshing]="managementControlPastExpiringContractsServiceHost.loading"
          [warn]="managementControlPastExpiringContractsServiceHost.warn"
          [lastUpdatedText]="managementControlPastExpiringContractsServiceHost.lastUpdatedText"
          (detailRequested)="managementControlPastExpiringContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">date_range</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlPastExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
          <past-expiring-contracts-kpi-service-host sink #managementControlPastExpiringContractsServiceHost
              [detailDialog]="managementControlPastExpiringContractsDetailDialog">
          </past-expiring-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlPastExpiringContractsServiceHost.summaryData && !managementControlPastExpiringContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlPastExpiringContractsServiceHost.summaryData) {
              <dual-data #managementControlPastExpiringContractsDualData
                [valueA]="managementControlPastExpiringContractsServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlPastExpiringContractsServiceHost.summaryData.consultant == 0 && !managementControlPastExpiringContractsServiceHost.warn ? managementControlPastExpiringContractsDualData.dataValueStyle.Zero : managementControlPastExpiringContractsDualData.dataValueStyle.None"
                [iconA]="managementControlPastExpiringContractsDualData.dataIcon.User"
                (valueAClick)="managementControlPastExpiringContractsServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlPastExpiringContractsServiceHost.summaryData.office"
                [valueBStyle]="managementControlPastExpiringContractsServiceHost.summaryData.office == 0 && !managementControlPastExpiringContractsServiceHost.warn ? managementControlPastExpiringContractsDualData.dataValueStyle.Zero : managementControlPastExpiringContractsDualData.dataValueStyle.None"
                [iconB]="managementControlPastExpiringContractsDualData.dataIcon.Office"
                (valueBClick)="managementControlPastExpiringContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlPastExpiringContractsServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlPastExpiringContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlPastExpiringContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlPastExpiringContractsDetailDialog
              [title]="'Vencimiento de contratos caducados'" cancelText="Cerrar"
              [size]="managementControlPastExpiringContractsDetailDialog.dialogSize.Large">
              @if (managementControlPastExpiringContractsDetailDialog.visible && managementControlPastExpiringContractsServiceHost.detailData) {
                <datatable
                  [columnDefinitions]="managementControlPastExpiringContractsServiceHost.detailData.columnDefinitions"
                  [data]="managementControlPastExpiringContractsServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlPastExpiringContractsDetailDialog.visible && managementControlPastExpiringContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlInmediateExpiringContractsHostVisible) {
        <kpi-host #managementControlInmediateExpiringContractsHost
          [title]="'Vtos. contratos hoy y semana'"
          tooltip="Contratos activos con fecha fin prevista de finalización 7 días"
          [refreshing]="managementControlInmediateExpiringContractsServiceHost.loading"
          [warn]="managementControlInmediateExpiringContractsServiceHost.warn"
          [lastUpdatedText]="managementControlInmediateExpiringContractsServiceHost.lastUpdatedText"
          (detailRequested)="managementControlInmediateExpiringContractsServiceHost.showDetail($event)">
          <i icon class="material-icons">date_range</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlInmediateExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
          <inmediate-expiring-contracts-kpi-service-host sink
              #managementControlInmediateExpiringContractsServiceHost
              [detailDialog]="managementControlInmediateExpiringContractsDetailDialog">
          </inmediate-expiring-contracts-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlInmediateExpiringContractsServiceHost.summaryData && !managementControlInmediateExpiringContractsServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlInmediateExpiringContractsServiceHost.summaryData) {
              <dual-data #managementControlInmediateExpiringContractsDualData
                [valueA]="managementControlInmediateExpiringContractsServiceHost.summaryData.consultant"
                [iconA]="managementControlInmediateExpiringContractsDualData.dataIcon.User"
                (valueAClick)="managementControlInmediateExpiringContractsServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlInmediateExpiringContractsServiceHost.summaryData.office"
                [iconB]="managementControlInmediateExpiringContractsDualData.dataIcon.Office"
                (valueBClick)="managementControlInmediateExpiringContractsServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlInmediateExpiringContractsServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlInmediateExpiringContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlInmediateExpiringContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlInmediateExpiringContractsDetailDialog
              [title]="'Vencimientos de contratos hoy y semana'" cancelText="Cerrar"
              [size]="managementControlInmediateExpiringContractsDetailDialog.dialogSize.Large">
              @if (managementControlInmediateExpiringContractsDetailDialog.visible && managementControlInmediateExpiringContractsServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlInmediateExpiringContractsServiceHost.detailData.columnDefinitions"
                  [data]="managementControlInmediateExpiringContractsServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlInmediateExpiringContractsDetailDialog.visible && managementControlInmediateExpiringContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlForecastExpiringContractsHostVisible) {
        <kpi-host #managementControlForecastExpiringContractsHost
          [title]="'Vencimiento contratos fecha prevista esta semana'"
          tooltip="Contratos activos con fecha fin prevista de finalización en esta semana"
          [refreshing]="managementControlForecastExpiringContractsServiceHost.loading"
          [warn]="managementControlForecastExpiringContractsServiceHost.warn"
          [lastUpdatedText]="managementControlForecastExpiringContractsServiceHost.lastUpdatedText" [size]="2"
          [hostsBarChart]="true"
          (detailRequested)="managementControlForecastExpiringContractsServiceHost.showDetailEx($event, { name: managementControlForecastExpiringContractsSelector.selectedOption.text });">
          <i icon class="material-icons">date_range</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlForecastExpiringContractsServiceHost.refresh()"></kpi-host-menu-option>
          <expiring-contracts-evolution-kpi-service-host sink
              #managementControlForecastExpiringContractsServiceHost
              [detailDialog]="managementControlForecastExpiringContractsDetailDialog">
          </expiring-contracts-evolution-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlForecastExpiringContractsServiceHost.summaryData && !managementControlForecastExpiringContractsServiceHost.summaryError) {
              <no-data></no-data>
            }
          </ng-container>
          <ng-container additionalData>
              <chart-dropdown #managementControlForecastExpiringContractsSelector
                  [hidden]="!managementControlForecastExpiringContractsServiceHost.summaryData"
                  [options]="managementControlForecastExpiringContractsServiceHost.summaryData">
              </chart-dropdown>
              @if (managementControlForecastExpiringContractsServiceHost.summaryData) {
                <bar-chart additionalData
                  [data]="managementControlForecastExpiringContractsSelector.selectedOption.value.barChartData"
                  [isVisible]="managementControlTab.isVisible" [showLegend]="false"
                  (clickData)="managementControlForecastExpiringContractsServiceHost.mergeFilter({ date: managementControlForecastExpiringContractsSelector.selectedOption.value.dates[$event.dataIndices[0]] })">
                </bar-chart>
              }
          </ng-container>
          @if (managementControlForecastExpiringContractsServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlForecastExpiringContractsServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlForecastExpiringContractsServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlForecastExpiringContractsDetailDialog
              [title]="'Vencimiento contratos fecha prevista esta semana'" cancelText="Cerrar"
              [size]="managementControlForecastExpiringContractsDetailDialog.dialogSize.Large">
              @if (managementControlForecastExpiringContractsDetailDialog.visible && managementControlForecastExpiringContractsServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlForecastExpiringContractsServiceHost.detailData.columnDefinitions"
                  [data]="managementControlForecastExpiringContractsServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlForecastExpiringContractsDetailDialog.visible && managementControlForecastExpiringContractsServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>

  <kpi-group #riskGroup [title]="'Riesgos'" [subtitle]="dashboardOwner">
    <kpi-group-row>
      @if (managementControlPendingActiveWorkersWoMedicalExaminationHostVisible) {
        <kpi-host #managementControlPendingActiveWorkersWoMedicalExaminationHost
          [title]="'RRMM obligatorio pend.'"
          tooltip="Trabajadores activos con RRMM obligatorio pendiente de enviar al SPA"
          [refreshing]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.loading"
          [warn]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.warn"
          [lastUpdatedText]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
          (detailRequested)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
          <i icon class="material-icons">favorite_border</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
          <pending-active-workers-wo-medical-examination-kpi-service-host sink
              #managementControlPendingActiveWorkersWoMedicalExaminationServiceHost
              [detailDialog]="managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog">
          </pending-active-workers-wo-medical-examination-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData && !managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
              <dual-data #managementControlPendingActiveWorkersWoMedicalExaminationDualData
                [valueA]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant == 0 ? managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
                [iconA]="managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
                (valueAClick)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
                [valueBStyle]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office == 0 ? managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
                [iconB]="managementControlPendingActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
                (valueBClick)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog
              [title]="'RRMM obligatorio pend.'" cancelText="Cerrar"
              [size]="managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
              @if (managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
                  [data]="managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlPendingActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlPendingActiveWorkersWoMedicalExaminationServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlExpiredActiveWorkersWoMedicalExaminationHostVisible) {
        <kpi-host #managementControlExpiredActiveWorkersWoMedicalExaminationHost
          [title]="'RRMM no obligatorio pend.'"
          tooltip="Trabajadores activos con RRMM no obligatorio pendiente de enviar al SPA"
          [refreshing]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.loading"
          [warn]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.warn"
          [lastUpdatedText]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
          (detailRequested)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
          <i icon class="material-icons">favorite_border</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
          <expired-active-workers-wo-medical-examination-kpi-service-host sink
              #managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost
              [detailDialog]="managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog">
          </expired-active-workers-wo-medical-examination-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData && !managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
              <dual-data #managementControlExpiredActiveWorkersWoMedicalExaminationDualData
                [valueA]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
                [iconA]="managementControlExpiredActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
                (valueAClick)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
                [iconB]="managementControlExpiredActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
                (valueBClick)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog
              [title]="'RRMM no obligatorio pend.'" cancelText="Cerrar"
              [size]="managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
              @if (managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
                  [data]="managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlExpiredActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlExpiredActiveWorkersWoMedicalExaminationServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }
      @if (managementControlProcessingActiveWorkersWoMedicalExaminationHostVisible) {
        <kpi-host #managementControlProcessingActiveWorkersWoMedicalExaminationHost
          [title]="'RRMM en proceso'"
          tooltip="Trabajadores activos con RRMM en proceso"
          [refreshing]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.loading"
          [warn]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.warn"
          [lastUpdatedText]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
          (detailRequested)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
          <i icon class="material-icons">favorite_border</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
          <processing-active-workers-wo-medical-examination-kpi-service-host sink
              #managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost
              [detailDialog]="managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog">
          </processing-active-workers-wo-medical-examination-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData && !managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
              <dual-data #managementControlProcessingActiveWorkersWoMedicalExaminationDualData
                [valueA]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant == 0 ? managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
                [iconA]="managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
                (valueAClick)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
                [valueBStyle]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryData.office == 0 ? managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Zero : managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataValueStyle.Warn"
                [iconB]="managementControlProcessingActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
                (valueBClick)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog
              [title]="'RRMM en proceso'" cancelText="Cerrar"
              [size]="managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
              @if (managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
                  [data]="managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlProcessingActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlProcessingActiveWorkersWoMedicalExaminationServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlFitActiveWorkersWoMedicalExaminationHostVisible) {
        <kpi-host #managementControlFitActiveWorkersWoMedicalExaminationHost
          [title]="'RRMM aptos'"
          tooltip="Trabajadores activos con RRMM Apto"
          [refreshing]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.loading"
          [warn]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.warn"
          [lastUpdatedText]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.lastUpdatedText"
          (detailRequested)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.showDetail($event)">
          <i icon class="material-icons">favorite_border</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.refresh()"></kpi-host-menu-option>
          <fit-active-workers-wo-medical-examination-kpi-service-host sink
              #managementControlFitActiveWorkersWoMedicalExaminationServiceHost
              [detailDialog]="managementControlFitActiveWorkersWoMedicalExaminationDetailDialog">
          </fit-active-workers-wo-medical-examination-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData && !managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData) {
              <dual-data #managementControlFitActiveWorkersWoMedicalExaminationDualData
                [valueA]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData.consultant"
                [iconA]="managementControlFitActiveWorkersWoMedicalExaminationDualData.dataIcon.User"
                (valueAClick)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryData.office"
                [iconB]="managementControlFitActiveWorkersWoMedicalExaminationDualData.dataIcon.Office"
                (valueBClick)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlFitActiveWorkersWoMedicalExaminationDetailDialog
              [title]="'RRMM aptos'" cancelText="Cerrar"
              [size]="managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.dialogSize.Large">
              @if (managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData.columnDefinitions"
                  [data]="managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlFitActiveWorkersWoMedicalExaminationDetailDialog.visible && managementControlFitActiveWorkersWoMedicalExaminationServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
    <kpi-group-row>
      @if (managementControlActiveWorkersWoPPEHostVisible) {
        <kpi-host #managementControlActiveWorkersWoPPEHost
          [title]="'Trab. activos sin epi'"
          tooltip="Trabajadores activos sin epi: Trabajadores que has quedado con el cliente que vas a entregar epis y no los tienen"
          [refreshing]="managementControlActiveWorkersWoPPEServiceHost.loading"
          [warn]="managementControlActiveWorkersWoPPEServiceHost.warn"
          [lastUpdatedText]="managementControlActiveWorkersWoPPEServiceHost.lastUpdatedText"
          (detailRequested)="managementControlActiveWorkersWoPPEServiceHost.showDetail($event)">
          <i icon class="icon ico-helmet"></i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlActiveWorkersWoPPEServiceHost.refresh()"></kpi-host-menu-option>
          <active-workers-wo-mandatory-ppe-kpi-service-host sink #managementControlActiveWorkersWoPPEServiceHost
              [detailDialog]="managementControlActiveWorkersWoPPEDetailDialog">
          </active-workers-wo-mandatory-ppe-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlActiveWorkersWoPPEServiceHost.summaryData && !managementControlActiveWorkersWoPPEServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlActiveWorkersWoPPEServiceHost.summaryData) {
              <dual-data #managementControlActiveWorkersWoPPEDualData
                [valueA]="managementControlActiveWorkersWoPPEServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlActiveWorkersWoPPEServiceHost.summaryData.consultant == 0 ? managementControlActiveWorkersWoPPEDualData.dataValueStyle.Zero : managementControlActiveWorkersWoPPEDualData.dataValueStyle.Warn"
                [iconA]="managementControlActiveWorkersWoPPEDualData.dataIcon.User"
                (valueAClick)="managementControlActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlActiveWorkersWoPPEServiceHost.summaryData.office"
                [valueBStyle]="managementControlActiveWorkersWoPPEServiceHost.summaryData.office == 0 ? managementControlActiveWorkersWoPPEDualData.dataValueStyle.Zero : managementControlActiveWorkersWoPPEDualData.dataValueStyle.Warn"
                [iconB]="managementControlActiveWorkersWoPPEDualData.dataIcon.Office"
                (valueBClick)="managementControlActiveWorkersWoPPEServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlActiveWorkersWoPPEServiceHost.summaryError) {
            <data-error errorMsg
              [errorMessage]="managementControlActiveWorkersWoPPEServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlActiveWorkersWoPPEServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlActiveWorkersWoPPEDetailDialog
              [title]="'Trabajadores activos sin epi'" cancelText="Cerrar"
              [size]="managementControlActiveWorkersWoPPEDetailDialog.dialogSize.Large">
              @if (managementControlActiveWorkersWoPPEDetailDialog.visible && managementControlActiveWorkersWoPPEServiceHost.detailData) {
                <datatable
                  [columnDefinitions]="managementControlActiveWorkersWoPPEServiceHost.detailData.columnDefinitions"
                  [data]="managementControlActiveWorkersWoPPEServiceHost.detailData.tabledata">
                </datatable>
              }

              @if (managementControlActiveWorkersWoPPEDetailDialog.visible && managementControlActiveWorkersWoPPEServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }

      @if (managementControlAbsencesHostVisible) {
        <kpi-host #managementControlAbsencesHost
          [title]="'Control absentismos'" tooltip="IT´s Accidentes y permiso maternidad y paternidad"
          [refreshing]="managementControlAbsencesServiceHost.loading"
          [warn]="managementControlAbsencesServiceHost.warn"
          [lastUpdatedText]="managementControlAbsencesServiceHost.lastUpdatedText"
          (detailRequested)="managementControlAbsencesServiceHost.showDetail($event)">
          <i icon class="material-icons">border_color</i>
          <kpi-host-menu-option menuOption [text]="'Actualizar'"
              (click)="managementControlAbsencesServiceHost.refresh()"></kpi-host-menu-option>
          <absences-kpi-service-host sink #managementControlAbsencesServiceHost
              [detailDialog]="managementControlAbsencesDetailDialog">
          </absences-kpi-service-host>
          <ng-container mainData>
            @if (!managementControlAbsencesServiceHost.summaryData && !managementControlAbsencesServiceHost.summaryError) {
              <no-data></no-data>
            }

            @if (managementControlAbsencesServiceHost.summaryData) {
              <dual-data #managementControlAbsencesDualData
                [valueA]="managementControlAbsencesServiceHost.summaryData.consultant"
                [valueAStyle]="managementControlAbsencesServiceHost.summaryData.consultant == 0 && !managementControlAbsencesServiceHost.warn ? managementControlAbsencesDualData.dataValueStyle.Zero : managementControlAbsencesDualData.dataValueStyle.None"
                [iconA]="managementControlAbsencesDualData.dataIcon.User"
                (valueAClick)="managementControlAbsencesServiceHost.mergeFilter({ consultant: true })"
                [valueB]="managementControlAbsencesServiceHost.summaryData.office"
                [valueBStyle]="managementControlAbsencesServiceHost.summaryData.office == 0 && !managementControlAbsencesServiceHost.warn ? managementControlAbsencesDualData.dataValueStyle.Zero : managementControlAbsencesDualData.dataValueStyle.None"
                [iconB]="managementControlAbsencesDualData.dataIcon.Office"
                (valueBClick)="managementControlAbsencesServiceHost.mergeFilter({ consultant: false })">
              </dual-data>
            }
          </ng-container>
          @if (managementControlAbsencesServiceHost.summaryError) {
             <data-error errorMsg [errorMessage]="managementControlAbsencesServiceHost.summaryError.message"
              (onRequestRefresh)="managementControlAbsencesServiceHost.refresh()">
            </data-error>
          }

          <modal-dialog detailDialog #managementControlAbsencesDetailDialog [title]="'Control absentismos'"
              cancelText="Cerrar" [size]="managementControlAbsencesDetailDialog.dialogSize.Large">
              @if (managementControlAbsencesDetailDialog.visible && managementControlAbsencesServiceHost.detailData) {
                <datatable [columnDefinitions]="managementControlAbsencesServiceHost.detailData.columnDefinitions"
                  [data]="managementControlAbsencesServiceHost.detailData.tabledata"
                  [rowStyleSelector]="managementControlAbsencesServiceHost.detailData.rowStyleSelector">
                </datatable>
              }

              @if (managementControlAbsencesDetailDialog.visible && managementControlAbsencesServiceHost.detailError) {
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <img src="assets/dashboard/link-broken@2x.png" alt="Ups! Tenemos un problema">
                  <span class="msg-error-title">Ups! Tenemos un problema</span>
                </div>
              }
          </modal-dialog>
        </kpi-host>
      }
    </kpi-group-row>
  </kpi-group>
</kpi-tab-content>
